import type {Vsop87Element, Vsop87Group} from '@app/types/Vsop87Types';

const VSOP87_L0: Vsop87Element = [
    [1.75347045673],
    [0.03341656456, 4.66925680417, 6283.0758499914],
    [0.00034894275, 4.62610241759, 12566.1516999828],
    [0.00003417571, 2.82886579606, 3.523118349],
    [0.00003497056, 2.74411800971, 5753.3848848968],
    [0.00003135896, 3.62767041758, 77713.7714681205],
    [0.00002676218, 4.41808351397, 7860.4193924392],
    [0.00002342687, 6.13516237631, 3930.2096962196],
    [0.00001273166, 2.03709655772, 529.6909650946],
    [0.00001324292, 0.74246356352, 11506.7697697936],
    [0.00000901855, 2.04505443513, 26.2983197998],
    [0.00001199167, 1.10962944315, 1577.3435424478],
    [0.00000857223, 3.50849156957, 398.1490034082],
    [0.00000779786, 1.17882652114, 5223.6939198022],
    [0.0000099025, 5.23268129594, 5884.9268465832],
    [0.00000753141, 2.53339053818, 5507.5532386674],
    [0.00000505264, 4.58292563052, 18849.2275499742],
    [0.00000492379, 4.20506639861, 775.522611324],
    [0.00000356655, 2.91954116867, 0.0673103028],
    [0.00000284125, 1.89869034186, 796.2980068164],
    [0.0000024281, 0.34481140906, 5486.777843175],
    [0.00000317087, 5.84901952218, 11790.6290886588],
    [0.00000271039, 0.31488607649, 10977.078804699],
    [0.0000020616, 4.80646606059, 2544.3144198834],
    [0.00000205385, 1.86947813692, 5573.1428014331],
    [0.00000202261, 2.45767795458, 6069.7767545534],
    [0.00000126184, 1.0830263021, 20.7753954924],
    [0.00000155516, 0.83306073807, 213.299095438],
    [0.00000115132, 0.64544911683, 0.9803210682],
    [0.00000102851, 0.63599846727, 4694.0029547076],
    [0.00000101724, 4.26679821365, 7.1135470008],
    [0.00000099206, 6.20992940258, 2146.1654164752],
    [0.00000132212, 3.41118275555, 2942.4634232916],
    [0.00000097607, 0.6810127227, 155.4203994342],
    [0.00000085128, 1.29870743025, 6275.9623029906],
    [0.00000074651, 1.75508916159, 5088.6288397668],
    [0.00000101895, 0.97569221824, 15720.8387848784],
    [0.00000084711, 3.67080093025, 71430.69561812909],
    [0.00000073547, 4.67926565481, 801.8209311238],
    [0.00000073874, 3.50319443167, 3154.6870848956],
    [0.00000078756, 3.03698313141, 12036.4607348882],
    [0.00000079637, 1.807913307, 17260.1546546904],
    [0.00000085803, 5.98322631256, 161000.6857376741],
    [0.00000056963, 2.78430398043, 6286.5989683404],
    [0.00000061148, 1.81839811024, 7084.8967811152],
    [0.00000069627, 0.83297596966, 9437.762934887],
    [0.00000056116, 4.38694880779, 14143.4952424306],
    [0.00000062449, 3.97763880587, 8827.3902698748],
    [0.00000051145, 0.28306864501, 5856.4776591154],
    [0.00000055577, 3.47006009062, 6279.5527316424],
    [0.00000041036, 5.36817351402, 8429.2412664666],
    [0.00000051605, 1.33282746983, 1748.016413067],
    [0.00000051992, 0.18914945834, 12139.5535091068],
    [0.00000049, 0.48735065033, 1194.4470102246],
    [0.000000392, 6.16832995016, 10447.3878396044],
    [0.00000035566, 1.77597314691, 6812.766815086],
    [0.0000003677, 6.04133859347, 10213.285546211],
    [0.00000036596, 2.56955238628, 1059.3819301892],
    [0.00000033291, 0.59309499459, 17789.845619785],
    [0.00000035954, 1.70876111898, 2352.8661537718],
    [0.00000040938, 2.39850881707, 19651.048481098],
    [0.00000030047, 2.73975123935, 1349.8674096588],
    [0.00000030412, 0.44294464135, 83996.84731811189],
    [0.00000023663, 0.48473567763, 8031.0922630584],
    [0.00000023574, 2.06527720049, 3340.6124266998],
    [0.00000021089, 4.14825464101, 951.7184062506],
    [0.00000024738, 0.21484762138, 3.5904286518],
    [0.00000025352, 3.16470953405, 4690.4798363586],
    [0.0000002282, 5.22197888032, 4705.7323075436],
    [0.00000021419, 1.42563735525, 16730.4636895958],
    [0.00000021891, 5.55594302562, 553.5694028424],
    [0.00000017481, 4.56052900359, 135.0650800354],
    [0.00000019925, 5.22208471269, 12168.0026965746],
    [0.0000001986, 5.77470167653, 6309.3741697912],
    [0.000000203, 0.37133792946, 283.8593188652],
    [0.00000014421, 4.19315332546, 242.728603974],
    [0.00000016225, 5.98837722564, 11769.8536931664],
    [0.00000015077, 4.19567181073, 6256.7775301916],
    [0.00000019124, 3.82219996949, 23581.2581773176],
    [0.00000018888, 5.38626880969, 149854.40013480789],
    [0.00000014346, 3.72355084422, 38.0276726358],
    [0.00000017898, 2.21490735647, 13367.9726311066],
    [0.00000012054, 2.62229588349, 955.5997416086],
    [0.00000011287, 0.17739328092, 4164.311989613],
    [0.00000013971, 4.40138139996, 6681.2248533996],
    [0.00000013621, 1.88934471407, 7632.9432596502],
    [0.00000012503, 1.13052412208, 5.5229243074],
    [0.00000010498, 5.35909518669, 1592.5960136328],
    [0.00000009803, 0.99947478995, 11371.7046897582],
    [0.0000000922, 4.57138609781, 4292.3308329504],
    [0.00000010327, 6.19982566125, 6438.4962494256],
    [0.00000012003, 1.003514567, 632.7837393132],
    [0.00000010827, 0.32734520222, 103.0927742186],
    [0.00000008356, 4.53902685948, 25132.3033999656],
    [0.00000010005, 6.0291496328, 5746.271337896],
    [0.00000008409, 3.29946744189, 7234.794256242],
    [0.00000008006, 5.82145271907, 28.4491874678],
    [0.00000010523, 0.93871805506, 11926.2544136688],
    [0.00000007686, 3.12142363172, 7238.6755916],
    [0.00000009378, 2.62414241032, 5760.4984318976],
    [0.00000008127, 6.11228001785, 4732.0306273434],
    [0.00000009232, 0.48343968736, 522.5774180938],
    [0.00000009802, 5.24413991147, 27511.4678735372],
    [0.00000007871, 0.99590177926, 5643.1785636774],
    [0.00000008123, 6.2705301365, 426.598190876],
    [0.00000009048, 5.33686335897, 6386.16862421],
    [0.0000000862, 4.16538210888, 7058.5984613154],
    [0.00000006297, 4.71724819317, 6836.6452528338],
    [0.00000007575, 3.97382858911, 11499.6562227928],
    [0.00000007756, 2.95729056763, 23013.5395395872],
    [0.00000007314, 0.60652505806, 11513.8833167944],
    [0.00000005955, 2.87641047971, 6283.14316029419],
    [0.00000006534, 5.79072926033, 18073.7049386502],
    [0.00000007188, 3.99831508699, 74.7815985673],
    [0.00000007346, 4.38582365437, 316.3918696566],
    [0.00000005413, 5.39199024641, 419.4846438752],
    [0.00000005127, 2.36062848786, 10973.55568635],
    [0.00000007056, 0.32258441903, 263.0839233728],
    [0.00000006625, 3.66475158672, 17298.1823273262],
    [0.00000006762, 5.91132535899, 90955.5516944961],
    [0.00000004938, 5.73672165674, 9917.6968745098],
    [0.00000005547, 2.45152597661, 12352.8526045448],
    [0.00000005958, 3.32051344676, 6283.0085396886],
    [0.00000004471, 2.06385999536, 7079.3738568078],
    [0.00000006153, 1.45823331144, 233141.31440436149],
    [0.00000004348, 4.4234217548, 5216.5803728014],
    [0.00000006123, 1.07494905258, 19804.8272915828],
    [0.00000004488, 3.6528503715, 206.1855484372],
    [0.0000000402, 0.83995823171, 20.3553193988],
    [0.00000005188, 4.06503864016, 6208.2942514241],
    [0.00000005307, 0.38217636096, 31441.6775697568],
    [0.00000003785, 2.34369213733, 3.881335358],
    [0.00000004497, 3.27230796845, 11015.1064773348],
    [0.00000004132, 0.92128915753, 3738.761430108],
    [0.00000003521, 5.97844807108, 3894.1818295422],
    [0.00000004215, 1.90601120623, 245.8316462294],
    [0.00000003701, 5.03069397926, 536.8045120954],
    [0.00000003865, 1.82634360607, 11856.2186514245],
    [0.00000003652, 1.01838584934, 16200.7727245012],
    [0.0000000339, 0.97785123922, 8635.9420037632],
    [0.00000003737, 2.95380107829, 3128.3887650958],
    [0.00000003507, 3.71291946325, 6290.1893969922],
    [0.00000003086, 3.64646921512, 10.6366653498],
    [0.00000003397, 1.10590684017, 14712.317116458],
    [0.00000003334, 0.83684924911, 6496.3749454294],
    [0.00000002805, 2.58504514144, 14314.1681130498],
    [0.0000000365, 1.08344142571, 88860.05707098669],
    [0.00000003388, 3.20185096055, 5120.6011455836],
    [0.00000003252, 3.47859752062, 6133.5126528568],
    [0.00000002553, 3.94869034189, 1990.745017041],
    [0.0000000352, 2.05559692878, 244287.60000722769],
    [0.00000002565, 1.560717849, 23543.23050468179],
    [0.00000002621, 3.85639359951, 266.6070417218],
    [0.00000002955, 3.39692949667, 9225.539273283],
    [0.00000002876, 6.02635617464, 154717.60988768269],
    [0.00000002395, 1.16131956403, 10984.1923516998],
    [0.00000003161, 1.32798718453, 10873.9860304804],
    [0.00000003163, 5.08946464629, 21228.3920235458],
    [0.00000002361, 4.27212906992, 6040.3472460174],
    [0.0000000303, 1.80209931347, 35371.8872659764],
    [0.00000002343, 3.576898605, 10969.9652576982],
    [0.00000002618, 2.57870156528, 22483.84857449259],
    [0.00000002113, 3.71393780256, 65147.6197681377],
    [0.00000002019, 0.81393923319, 170.6728706192],
    [0.00000002003, 0.38091017375, 6172.869528772],
    [0.00000002506, 3.74379142438, 10575.4066829418],
    [0.00000002381, 0.10581361289, 7.046236698],
    [0.00000001949, 4.86892513469, 36.0278666774],
    [0.00000002074, 4.2279477457, 5650.2921106782],
    [0.00000001924, 5.5946054986, 6282.0955289232],
    [0.00000001949, 1.07002512703, 5230.807466803],
    [0.00000001988, 5.19736046771, 6262.300454499],
    [0.00000001887, 3.74365662683, 23.8784377478],
    [0.00000001787, 1.25929682929, 12559.038152982],
    [0.00000001883, 1.90364058477, 15.252471185],
    [0.00000001816, 3.68083868442, 15110.4661198662],
    [0.00000001701, 4.4110589538, 110.2063212194],
    [0.0000000199, 3.93295788548, 6206.8097787158],
    [0.00000002103, 0.75354917468, 13521.7514415914],
    [0.00000001774, 0.48747535361, 1551.045222648],
    [0.00000001882, 0.86684493432, 22003.9146348698],
    [0.00000001924, 1.22898324132, 709.9330485583],
    [0.00000002009, 4.6285092198, 6037.244203762],
    [0.00000001924, 0.60231842508, 6284.0561710596],
    [0.00000001596, 3.98332956992, 13916.0191096416],
    [0.00000001664, 4.41939715469, 8662.240323563],
    [0.00000001971, 1.04560500503, 18209.33026366019],
    [0.00000001942, 4.31335979989, 6244.9428143536],
    [0.00000001476, 0.93271367331, 2379.1644735716],
    [0.0000000181, 0.49112137707, 1.4844727083],
    [0.00000001346, 1.51574702235, 4136.9104335162],
    [0.00000001528, 5.61835711404, 6127.6554505572],
    [0.00000001791, 3.22187270126, 39302.096962196],
    [0.00000001747, 3.05638656738, 18319.5365848796],
    [0.00000001431, 4.51153808594, 20426.571092422],
    [0.00000001695, 0.22047718414, 25158.6017197654],
    [0.00000001242, 4.46665769933, 17256.6315363414],
    [0.00000001463, 4.69242679213, 14945.3161735544],
    [0.00000001205, 1.86912144659, 4590.910180489],
    [0.00000001192, 2.74227166898, 12569.6748183318],
    [0.00000001222, 5.18120087482, 5333.9002410216],
    [0.0000000139, 5.42894648983, 143571.32428481648],
    [0.00000001473, 1.70479245805, 11712.9553182308],
    [0.00000001362, 2.61069503292, 6062.6632075526],
    [0.00000001148, 6.0300180054, 3634.6210245184],
    [0.00000001198, 5.15294130422, 10177.2576795336],
    [0.00000001266, 0.11421493643, 18422.62935909819],
    [0.00000001411, 1.09908857534, 3496.032826134],
    [0.00000001349, 2.99805109633, 17654.7805397496],
    [0.00000001253, 2.79850152848, 167283.76158766549],
    [0.00000001311, 1.60942984879, 5481.2549188676],
    [0.00000001079, 6.20304501787, 3.2863574178],
    [0.00000001181, 1.20653776978, 131.5419616864],
    [0.00000001254, 5.45103277798, 6076.8903015542],
    [0.00000001035, 2.32142722747, 7342.4577801806],
    [0.00000001117, 0.38838354256, 949.1756089698],
    [0.00000000966, 3.18341890851, 11087.2851259184],
    [0.00000001171, 3.39635049962, 12562.6285816338],
    [0.00000001121, 0.72627490378, 220.4126424388],
    [0.00000001024, 2.19378315386, 11403.676995575],
    [0.00000000888, 3.91173199285, 4686.8894077068],
    [0.0000000091, 1.98802695087, 735.8765135318],
    [0.0000000083, 0.48984915507, 24072.9214697764],
    [0.00000001096, 6.17377835617, 5436.9930152402],
    [0.00000000908, 0.44959639433, 7477.522860216],
    [0.00000000974, 1.52996238356, 9623.6882766912],
    [0.0000000084, 1.79543266333, 5429.8794682394],
    [0.00000000778, 6.17699177946, 38.1330356378],
    [0.00000000776, 4.09855402433, 14.2270940016],
    [0.00000001068, 4.64200173735, 43232.3066584156],
    [0.00000000954, 1.49988435748, 1162.4747044078],
    [0.00000000907, 0.86986870809, 10344.2950653858],
    [0.00000000931, 4.06044689031, 28766.924424484],
    [0.00000000739, 5.04368197372, 639.897286314],
    [0.00000000937, 3.4688469896, 1589.0728952838],
    [0.00000000763, 5.86304932998, 16858.4825329332],
    [0.00000000953, 4.20801492835, 11190.377900137],
    [0.00000000708, 1.7289998894, 13095.8426650774],
    [0.00000000969, 1.64439522215, 29088.811415985],
    [0.00000000717, 0.16688678895, 11.729352836],
    [0.00000000962, 3.53092337542, 12416.5885028482],
    [0.00000000747, 5.77866940346, 12592.4500197826],
    [0.00000000672, 1.91095796194, 3.9321532631],
    [0.00000000671, 5.46240843677, 18052.9295431578],
    [0.00000000675, 6.28311558823, 4535.0594369244],
    [0.00000000684, 0.3997501208, 5849.3641121146],
    [0.00000000799, 0.29851185294, 12132.439962106],
    [0.00000000758, 0.96370823331, 1052.2683831884],
    [0.00000000782, 5.33878339919, 13517.8701062334],
    [0.0000000073, 1.70106160291, 17267.26820169119],
    [0.00000000749, 2.59599901875, 11609.8625440122],
    [0.00000000734, 2.78417782952, 640.8776073822],
    [0.00000000688, 5.15048287468, 16496.3613962024],
    [0.0000000077, 1.62469589333, 4701.1165017084],
    [0.00000000633, 2.20587893893, 25934.1243310894],
    [0.0000000076, 4.21317219403, 377.3736079158],
    [0.00000000584, 2.13420121623, 10557.5941608238],
    [0.00000000574, 0.24250054587, 9779.1086761254],
    [0.00000000573, 3.16435264609, 533.2140834436],
    [0.00000000685, 3.19344289472, 12146.6670561076],
    [0.00000000675, 0.96179233959, 10454.5013866052],
    [0.00000000648, 1.46327342555, 6268.8487559898],
    [0.00000000589, 2.50543543638, 3097.88382272579],
    [0.00000000551, 5.28099026956, 9388.0059094152],
    [0.00000000696, 3.65342150016, 4804.209275927],
    [0.00000000669, 2.51030077026, 2388.8940204492],
    [0.0000000055, 0.06883864342, 20199.094959633],
    [0.00000000629, 4.13350995675, 45892.73043315699],
    [0.00000000678, 6.09190163533, 135.62532501],
    [0.00000000593, 1.50136257618, 226858.23855437008],
    [0.00000000542, 3.58573645173, 6148.010769956],
    [0.00000000682, 5.02203067788, 17253.04110768959],
    [0.00000000565, 4.2930923861, 11933.3679606696],
    [0.00000000486, 0.77746204893, 27.4015560968],
    [0.00000000503, 0.58963565969, 15671.0817594066],
    [0.00000000616, 4.06539884128, 227.476132789],
    [0.00000000583, 6.12695541996, 18875.525869774],
    [0.00000000537, 2.1505644098, 21954.15760939799],
    [0.00000000669, 6.06986269566, 47162.5163546352],
    [0.00000000475, 0.4034384211, 6915.8595893046],
    [0.0000000054, 2.83444222174, 5326.7866940208],
    [0.0000000053, 5.26359885263, 10988.808157535],
    [0.00000000582, 3.24533095664, 153.7788104848],
    [0.00000000641, 3.24711791371, 2107.0345075424],
    [0.00000000621, 3.09698523779, 33019.0211122046],
    [0.00000000466, 3.14982372198, 10440.2742926036],
    [0.00000000466, 0.90708835657, 5966.6839803348],
    [0.00000000528, 0.8192645447, 813.5502839598],
    [0.00000000603, 3.81378921927, 316428.22867391503],
    [0.00000000559, 1.81894804124, 17996.0311682222],
    [0.00000000437, 2.28625594435, 6303.8512454838],
    [0.00000000518, 4.86069178322, 20597.2439630412],
    [0.00000000424, 6.23520018693, 6489.2613984286],
    [0.00000000518, 6.17617826756, 0.2438174835],
    [0.00000000404, 5.72804304258, 5642.1982426092],
    [0.00000000458, 1.34117773915, 6287.0080032545],
    [0.00000000548, 5.6845445832, 155427.54293624099],
    [0.00000000547, 1.03391472061, 3646.3503773544],
    [0.00000000428, 4.69800981138, 846.0828347512],
    [0.00000000413, 6.02520699406, 6279.4854213396],
    [0.00000000534, 3.03030638223, 66567.48586525429],
    [0.00000000383, 1.49056949125, 19800.9459562248],
    [0.0000000041, 5.28319622279, 18451.07854656599],
    [0.00000000352, 4.68891600359, 4907.3020501456],
    [0.0000000048, 5.36572651091, 348.924420448],
    [0.00000000344, 5.89157452896, 6546.1597733642],
    [0.0000000034, 0.3755742644, 13119.72110282519],
    [0.00000000434, 4.98417785901, 6702.5604938666],
    [0.00000000332, 2.68902519126, 29296.6153895786],
    [0.00000000448, 2.16478480251, 5905.7022420756],
    [0.00000000344, 2.06546633735, 49.7570254718],
    [0.00000000315, 1.24023811803, 4061.2192153944],
    [0.00000000324, 2.30897526929, 5017.508371365],
    [0.00000000413, 0.17171692962, 6286.6662786432],
    [0.00000000431, 3.86601101393, 12489.8856287072],
    [0.00000000349, 4.55372342974, 4933.2084403326],
    [0.00000000323, 0.41971136084, 10770.8932562618],
    [0.00000000341, 2.68612860807, 11.0457002639],
    [0.00000000316, 3.52936906658, 17782.7320727842],
    [0.00000000315, 5.63357264999, 568.8218740274],
    [0.0000000034, 3.83571212349, 10660.6869350424],
    [0.00000000297, 0.62691416712, 20995.3929664494],
    [0.00000000405, 1.00085779471, 16460.33352952499],
    [0.00000000414, 1.21998752076, 51092.7260508548],
    [0.00000000336, 4.71465945226, 6179.9830757728],
    [0.00000000361, 3.71227508354, 28237.2334593894],
    [0.00000000385, 6.21925225757, 24356.7807886416],
    [0.00000000327, 1.05606504715, 11919.140866668],
    [0.00000000327, 6.14222420989, 6254.6266625236],
    [0.00000000268, 2.47224339737, 664.75604513],
    [0.00000000269, 1.86207884109, 23141.5583829246],
    [0.00000000345, 0.93461290184, 6058.7310542895],
    [0.00000000296, 4.5168755718, 6418.1409300268],
    [0.00000000353, 4.50033653082, 36949.2308084242],
    [0.0000000026, 4.04963546305, 6525.8044539654],
    [0.00000000298, 2.20046722622, 156137.47598479928],
    [0.00000000253, 3.49900838384, 29864.334027309],
    [0.00000000254, 2.44901693835, 5331.3574437408],
    [0.00000000296, 0.84347588787, 5729.506447149],
    [0.00000000298, 1.29194706125, 22805.7355659936],
    [0.00000000241, 2.00721280805, 16737.5772365966],
    [0.00000000311, 1.23668016334, 6281.5913772831],
    [0.0000000024, 2.51650377121, 6245.0481773556],
    [0.00000000332, 3.55576945724, 7668.6374249425],
    [0.00000000264, 4.44052061202, 12964.300703391],
    [0.00000000257, 1.79654471948, 11080.1715789176],
    [0.0000000026, 3.3307759842, 5888.4499649322],
    [0.00000000285, 0.3088636143, 11823.1616394502],
    [0.0000000029, 5.70141882483, 77.673770428],
    [0.00000000255, 4.0093966444, 5881.4037282342],
    [0.00000000253, 4.73318493678, 16723.350142595],
    [0.00000000228, 0.95333661324, 5540.0857894588],
    [0.00000000319, 1.38633229189, 163096.18036118349],
    [0.00000000224, 1.65156322696, 10027.9031957292],
    [0.00000000226, 0.34106460604, 17796.9591667858],
    [0.00000000236, 4.19817431922, 19.66976089979],
    [0.0000000028, 4.1408026897, 12539.853380183],
    [0.00000000275, 5.50306930248, 32.5325507914],
    [0.00000000223, 5.23334210294, 56.8983749356],
    [0.00000000217, 6.08587881787, 6805.6532680852],
    [0.0000000028, 4.52472044653, 6016.4688082696],
    [0.00000000227, 5.06509843737, 6277.552925684],
    [0.00000000226, 5.17755154305, 11720.0688652316],
    [0.00000000245, 3.96486270306, 22.7752014508],
    [0.0000000022, 4.7207808197, 6.62855890001],
    [0.00000000207, 5.71701403951, 41.5507909848],
    [0.00000000204, 3.9122741125, 2699.7348193176],
    [0.00000000209, 0.86881969011, 6321.1035226272],
    [0.000000002, 2.11984445273, 4274.5183108324],
    [0.000000002, 5.39839888163, 6019.9919266186],
    [0.00000000209, 5.67606291663, 11293.4706743556],
    [0.00000000252, 1.64965729351, 9380.9596727172],
    [0.00000000275, 5.04826903506, 73.297125859],
    [0.00000000208, 1.88207277133, 11300.5842213564],
    [0.00000000272, 0.74640926842, 1975.492545856],
    [0.00000000199, 3.30836672397, 22743.4093795164],
    [0.00000000269, 4.48560812155, 64471.99124174489],
    [0.00000000192, 2.17464236325, 5863.5912061162],
    [0.00000000228, 5.85373115869, 128.0188433374],
    [0.00000000261, 2.64321183295, 55022.9357470744],
    [0.0000000022, 5.75012110079, 29.429508536],
    [0.00000000187, 4.03230554718, 467.9649903544],
    [0.000000002, 5.60556112058, 1066.49547719],
    [0.00000000231, 1.09802712785, 12341.8069042809],
    [0.00000000199, 0.295006252, 149.5631971346],
    [0.00000000249, 5.10473210814, 7875.6718636242],
    [0.00000000208, 0.93013835019, 14919.0178537546],
    [0.00000000179, 0.87104393079, 12721.572099417],
    [0.00000000203, 1.56920753653, 28286.9904848612],
    [0.00000000179, 2.47036386443, 16062.1845261168],
    [0.00000000198, 3.54061588502, 30.914125635],
    [0.00000000171, 3.45356518113, 5327.4761083828],
    [0.00000000183, 0.72325421604, 6272.0301497275],
    [0.00000000216, 2.97174580686, 19402.7969528166],
    [0.00000000168, 2.51550550242, 23937.856389741],
    [0.00000000195, 0.09045393425, 156.4007205024],
    [0.00000000179, 4.4947179809, 31415.379249957],
    [0.00000000216, 0.42177594328, 23539.7073863328],
    [0.00000000189, 0.37542530191, 9814.6041002912],
    [0.00000000218, 2.36835880025, 16627.3709153772],
    [0.00000000166, 4.23182968446, 16840.67001081519],
    [0.000000002, 2.02153258098, 16097.6799502826],
    [0.00000000169, 0.91318727, 95.9792272178],
    [0.00000000211, 5.73370637657, 151.8972810852],
    [0.00000000204, 0.42643085174, 515.463871093],
    [0.00000000212, 3.00233538977, 12043.574281889],
    [0.00000000192, 5.46153589821, 6379.0550772092],
    [0.00000000165, 1.38698167064, 4171.4255366138],
    [0.0000000016, 6.23798383332, 202.2533951741],
    [0.00000000215, 0.20889073407, 5621.8429232104],
    [0.00000000181, 4.12439203622, 13341.6743113068],
    [0.00000000153, 1.24460848836, 29826.3063546732],
    [0.0000000015, 3.12999753018, 799.8211251654],
    [0.00000000175, 4.55671604437, 239424.39025435288],
    [0.00000000192, 1.33928820063, 394.6258850592],
    [0.00000000149, 2.65697593276, 21.335640467],
    [0.00000000146, 5.58021191726, 412.3710968744],
    [0.00000000156, 3.75650175503, 12323.4230960088],
    [0.00000000143, 3.75708566606, 58864.5439181463],
    [0.00000000143, 3.28248547724, 29.8214381488],
    [0.00000000144, 1.07862546598, 1265.5674786264],
    [0.00000000148, 0.23389236655, 10021.8372800994],
    [0.00000000193, 5.92751083086, 40879.4405046438],
    [0.0000000014, 4.97612440269, 158.9435177832],
    [0.00000000148, 2.61640453469, 17157.0618804718],
    [0.00000000141, 3.66871308723, 26084.0218062162],
    [0.00000000147, 5.09968173403, 661.232926781],
    [0.00000000146, 4.96885605695, 57375.8019008462],
    [0.00000000142, 0.78678347839, 12779.4507954208],
    [0.00000000134, 4.79432636012, 111.1866422876],
    [0.0000000014, 1.27748013377, 107.6635239386],
    [0.00000000169, 2.74893543762, 26735.9452622132],
    [0.00000000165, 3.95288000638, 6357.8574485587],
    [0.00000000183, 5.43418358741, 369.6998159404],
    [0.00000000134, 3.09132862833, 17.812522118],
    [0.00000000132, 3.05633896779, 22490.9621214934],
    [0.00000000134, 4.09472795832, 6599.467719648],
    [0.00000000181, 4.22950689891, 966.9708774356],
    [0.00000000152, 5.28885894415, 12669.2444742014],
    [0.0000000015, 5.86819430908, 97238.62754448749],
    [0.00000000142, 5.87266532526, 22476.73502749179],
    [0.00000000145, 5.07330784304, 87.30820453981],
    [0.00000000133, 5.65471067133, 31.9723058168],
    [0.00000000124, 2.83326217072, 12566.2190102856],
    [0.00000000135, 3.12861731644, 32217.2001810808],
    [0.00000000137, 0.86487461904, 9924.8104215106],
    [0.00000000172, 1.98369595114, 174242.4659640497],
    [0.0000000017, 4.41115280254, 327574.51427678125],
    [0.00000000151, 0.46542099527, 39609.6545831656],
    [0.00000000148, 2.13439571118, 491.6632924588],
    [0.00000000153, 3.78801830344, 17363.24742890899],
    [0.00000000165, 5.31654110459, 16943.7627850338],
    [0.00000000165, 4.06747587817, 58953.145443294],
    [0.00000000118, 0.63846333239, 6.0659156298],
    [0.00000000159, 0.86086959274, 221995.02880149524],
    [0.00000000119, 5.96432932413, 1385.8952763362],
    [0.00000000114, 5.16516114595, 25685.872802808],
    [0.00000000112, 3.39403722178, 21393.5419698576],
    [0.00000000112, 4.92889233335, 56.8032621698],
    [0.00000000119, 2.40637635942, 18635.9284545362],
    [0.00000000115, 0.23374479051, 418.9243989006],
    [0.00000000122, 0.93575234049, 24492.40611365159],
    [0.00000000115, 4.58880032176, 26709.6469424134],
    [0.0000000013, 4.85539251, 22345.2603761082],
    [0.0000000014, 1.09413073202, 44809.6502008634],
    [0.00000000112, 6.05401806281, 433.7117378768],
    [0.00000000104, 1.54931540602, 127.9515330346],
    [0.00000000105, 4.82620858888, 33794.5437235286],
    [0.00000000102, 4.12448497391, 15664.03552270859],
    [0.00000000107, 4.67919356465, 77690.75950573849],
    [0.00000000118, 4.5232017012, 19004.6479494084],
    [0.00000000107, 5.71774478555, 77736.78343050249],
    [0.00000000143, 1.81201813018, 4214.0690150848],
    [0.00000000125, 1.14419195615, 625.6701923124],
    [0.00000000124, 3.27736514057, 12566.08438968],
    [0.0000000011, 1.08682570828, 2787.0430238574],
    [0.00000000105, 1.78318141871, 18139.2945014159],
    [0.00000000102, 4.75119578149, 12242.6462833254],
    [0.00000000137, 1.43510636754, 86464.61331683119],
    [0.00000000101, 4.91289409429, 401.6721217572],
    [0.00000000129, 1.23567904485, 12029.3471878874],
    [0.00000000138, 2.45654707999, 7576.560073574],
    [0.00000000103, 0.40004073416, 90279.92316810328],
    [0.00000000108, 0.9898977494, 5636.0650166766],
    [0.00000000117, 5.17362872063, 34520.3093093808],
    [0.000000001, 3.95534628189, 5547.1993364596],
    [0.00000000098, 1.28118280598, 21548.9623692918],
    [0.00000000097, 3.34717130592, 16310.9790457206],
    [0.00000000098, 4.37041908717, 34513.2630726828],
    [0.00000000125, 2.7216443296, 24065.80792277559],
    [0.00000000102, 0.66938025772, 10239.5838660108],
    [0.00000000119, 1.21689479331, 1478.8665740644],
    [0.00000000094, 1.99595224256, 13362.4497067992],
    [0.00000000094, 4.30965982872, 26880.3198130326],
    [0.00000000095, 2.89807657534, 34911.412076091],
    [0.00000000106, 1.0015665359, 16522.6597160022],
    [0.00000000097, 0.89642320201, 71980.63357473118],
    [0.00000000116, 4.19967201116, 206.7007372966],
    [0.00000000099, 1.37437847718, 1039.0266107904],
    [0.00000000126, 3.21642544972, 305281.94307104882],
    [0.00000000094, 0.6899787606, 7834.1210726394],
    [0.00000000094, 5.58132218606, 3104.9300594238],
    [0.00000000095, 3.0382374111, 8982.810669309],
    [0.00000000108, 0.52696637156, 276.7457718644],
    [0.00000000124, 3.43899862683, 172146.97134054029],
    [0.00000000102, 1.04031728553, 95143.1329209781],
    [0.00000000104, 3.39218586218, 290.972865866],
    [0.0000000011, 3.68205877433, 22380.755800274],
    [0.00000000117, 0.78475956902, 83286.91426955358],
    [0.00000000083, 0.18241793425, 15141.390794312],
    [0.00000000089, 4.45371820659, 792.7748884674],
    [0.00000000082, 4.80703651241, 6819.8803620868],
    [0.00000000087, 3.43122851097, 27707.5424942948],
    [0.00000000101, 5.32081603011, 2301.58581590939],
    [0.00000000082, 0.87060089842, 10241.2022911672],
    [0.00000000086, 4.61919461931, 36147.4098773004],
    [0.00000000095, 2.87032884659, 23020.65308658799],
    [0.00000000088, 3.2113316569, 33326.5787331742],
    [0.0000000008, 1.84900424847, 21424.4666443034],
    [0.00000000101, 4.18796434479, 30666.1549584328],
    [0.00000000107, 5.77864921649, 34115.1140692746],
    [0.00000000104, 1.08739495962, 6288.5987742988],
    [0.0000000011, 3.32898859416, 72140.62866668739],
    [0.00000000087, 4.40657711727, 142.1786270362],
    [0.00000000109, 1.94546030825, 24279.10701821359],
    [0.00000000087, 4.32472045435, 742.9900605326],
    [0.00000000107, 4.91580912547, 277.0349937414],
    [0.00000000088, 2.10180220766, 26482.1708096244],
    [0.00000000086, 4.01887374432, 12491.3701014155],
    [0.00000000106, 5.49092372854, 62883.3551395136],
    [0.0000000008, 6.19781316983, 6709.6740408674],
    [0.00000000088, 2.09872810657, 238004.52415723629],
    [0.00000000083, 4.90662164029, 51.28033786241],
    [0.00000000095, 4.13387406591, 18216.443810661],
    [0.00000000078, 6.0694939168, 148434.53403769129],
    [0.00000000079, 3.03048221644, 838.9692877504],
    [0.00000000074, 5.49813051211, 29026.48522950779],
    [0.00000000073, 3.05008665738, 567.7186377304],
    [0.00000000084, 0.46604373274, 45.1412196366],
    [0.00000000093, 2.52267536308, 48739.859897083],
    [0.00000000076, 1.76418124905, 41654.9631159678],
    [0.00000000067, 5.77851227793, 6311.5250374592],
    [0.00000000062, 3.32967880172, 15508.6151232744],
    [0.00000000079, 5.59773841328, 71960.38658322369],
    [0.00000000057, 3.90629505268, 5999.2165311262],
    [0.00000000061, 0.05695043232, 7856.89627409019],
    [0.00000000061, 5.63297958433, 7863.9425107882],
    [0.00000000065, 3.72178394016, 12573.2652469836],
    [0.00000000057, 4.18217219541, 26087.9031415742],
    [0.00000000066, 3.92262333487, 69853.35207568129],
    [0.00000000053, 5.51119362045, 77710.24834977149],
    [0.00000000053, 4.88573986961, 77717.29458646949],
    [0.00000000062, 2.88876342225, 9411.4646150872],
    [0.00000000051, 1.12657183874, 82576.98122099529],
    [0.00000000045, 2.95671076719, 24602.61243487099],
    [0.0000000004, 5.55145719241, 12565.1713789146],
    [0.00000000039, 1.20838190039, 18842.11400297339],
    [0.00000000045, 3.18590558749, 45585.1728121874],
    [0.00000000049, 2.44790934886, 13613.804277336],
];

const VSOP87_L1: Vsop87Element = [
    [6283.31966747491],
    [0.00206058863, 2.67823455584, 6283.0758499914],
    [0.0000430343, 2.63512650414, 12566.1516999828],
    [0.00000425264, 1.59046980729, 3.523118349],
    [0.00000108977, 2.96618001993, 1577.3435424478],
    [0.00000093478, 2.59212835365, 18849.2275499742],
    [0.00000119261, 5.79557487799, 26.2983197998],
    [0.00000072122, 1.13846158196, 529.6909650946],
    [0.00000067768, 1.87472304791, 398.1490034082],
    [0.00000067327, 4.40918235168, 5507.5532386674],
    [0.00000059027, 2.8879703846, 5223.6939198022],
    [0.00000055976, 2.17471680261, 155.4203994342],
    [0.00000045407, 0.39803079805, 796.2980068164],
    [0.00000036369, 0.46624739835, 775.522611324],
    [0.00000028958, 2.64707383882, 7.1135470008],
    [0.00000019097, 1.84628332577, 5486.777843175],
    [0.00000020844, 5.34138275149, 0.9803210682],
    [0.00000018508, 4.96855124577, 213.299095438],
    [0.00000016233, 0.03216483047, 2544.3144198834],
    [0.00000017293, 2.99116864949, 6275.9623029906],
    [0.00000015832, 1.43049285325, 2146.1654164752],
    [0.00000014615, 1.20532366323, 10977.078804699],
    [0.00000011877, 3.25804815607, 5088.6288397668],
    [0.00000011514, 2.07502418155, 4694.0029547076],
    [0.00000009721, 4.23925472239, 1349.8674096588],
    [0.00000009969, 1.30262991097, 6286.5989683404],
    [0.00000009452, 2.69957062864, 242.728603974],
    [0.00000012461, 2.83432285512, 1748.016413067],
    [0.00000011808, 5.2737979048, 1194.4470102246],
    [0.00000008577, 5.64475868067, 951.7184062506],
    [0.00000010641, 0.76614199202, 553.5694028424],
    [0.00000007576, 5.30062664886, 2352.8661537718],
    [0.00000005834, 1.76649917904, 1059.3819301892],
    [0.00000006385, 2.65033984967, 9437.762934887],
    [0.00000005223, 5.66135767624, 71430.69561812909],
    [0.00000005305, 0.90857521574, 3154.6870848956],
    [0.00000006101, 4.66632584188, 4690.4798363586],
    [0.0000000433, 0.24102555403, 6812.766815086],
    [0.00000005041, 1.42490103709, 6438.4962494256],
    [0.00000004259, 0.77355900599, 10447.3878396044],
    [0.00000005198, 1.85353197345, 801.8209311238],
    [0.00000003744, 2.00119516488, 8031.0922630584],
    [0.00000003558, 2.42901552681, 14143.4952424306],
    [0.00000003372, 3.86210700128, 1592.5960136328],
    [0.00000003374, 0.88776219727, 12036.4607348882],
    [0.00000003175, 3.18785710594, 4705.7323075436],
    [0.00000003221, 0.61599835472, 8429.2412664666],
    [0.00000004132, 5.23992859705, 7084.8967811152],
    [0.0000000297, 6.07026318493, 4292.3308329504],
    [0.000000029, 2.32464208411, 20.3553193988],
    [0.00000003504, 4.79975694359, 6279.5527316424],
    [0.0000000295, 1.43108874817, 5746.271337896],
    [0.00000002697, 4.80368225199, 7234.794256242],
    [0.00000002531, 6.22290682655, 6836.6452528338],
    [0.00000002745, 0.93466065396, 5760.4984318976],
    [0.0000000325, 3.39954640038, 7632.9432596502],
    [0.00000002277, 5.00277837672, 17789.845619785],
    [0.00000002075, 3.95534978634, 10213.285546211],
    [0.00000002061, 2.22411683077, 5856.4776591154],
    [0.00000002252, 5.67166499885, 11499.6562227928],
    [0.00000002148, 5.20184578235, 11513.8833167944],
    [0.00000001886, 0.53198320577, 3340.6124266998],
    [0.00000001875, 4.73511970207, 83996.84731811189],
    [0.0000000206, 2.54987293999, 25132.3033999656],
    [0.00000001794, 1.47435409831, 4164.311989613],
    [0.00000001778, 3.02473091781, 5.5229243074],
    [0.00000002029, 0.90960209983, 6256.7775301916],
    [0.00000002075, 2.26767270157, 522.5774180938],
    [0.00000001772, 3.02622802353, 5753.3848848968],
    [0.00000001569, 6.12410242782, 5216.5803728014],
    [0.0000000159, 4.63713748247, 3.2863574178],
    [0.00000001542, 4.20004448567, 13367.9726311066],
    [0.00000001427, 1.19088061711, 3894.1818295422],
    [0.00000001375, 3.09301252193, 135.0650800354],
    [0.00000001359, 4.24532506641, 426.598190876],
    [0.0000000134, 5.76511818622, 6040.3472460174],
    [0.00000001284, 3.08524663344, 5643.1785636774],
    [0.0000000125, 3.07748157144, 11926.2544136688],
    [0.00000001551, 3.07665451458, 6681.2248533996],
    [0.00000001268, 2.09196018331, 6290.1893969922],
    [0.00000001144, 3.24444699514, 12168.0026965746],
    [0.00000001248, 3.44504937285, 536.8045120954],
    [0.00000001118, 2.31829670425, 16730.4636895958],
    [0.00000001105, 5.31966001019, 23.8784377478],
    [0.00000001051, 3.75015946014, 7860.4193924392],
    [0.00000001025, 2.44688534235, 1990.745017041],
    [0.00000000962, 0.81771017882, 3.881335358],
    [0.0000000091, 0.41727865299, 7079.3738568078],
    [0.00000000883, 5.16833917651, 11790.6290886588],
    [0.00000000957, 4.07673573735, 6127.6554505572],
    [0.0000000111, 3.90096793825, 11506.7697697936],
    [0.00000000802, 3.88778875582, 10973.55568635],
    [0.0000000078, 2.39934293755, 1589.0728952838],
    [0.00000000758, 1.30034364248, 103.0927742186],
    [0.00000000749, 4.962758033, 6496.3749454294],
    [0.00000000765, 3.36312388424, 36.0278666774],
    [0.00000000915, 5.41543742089, 206.1855484372],
    [0.00000000776, 2.57589093871, 11371.7046897582],
    [0.00000000772, 3.98369209464, 955.5997416086],
    [0.00000000749, 5.17890001805, 10969.9652576982],
    [0.00000000806, 0.34218864254, 9917.6968745098],
    [0.00000000728, 5.20962563787, 38.0276726358],
    [0.00000000685, 2.77592961854, 20.7753954924],
    [0.00000000636, 4.28242193632, 28.4491874678],
    [0.00000000608, 5.63278508906, 10984.1923516998],
    [0.00000000704, 5.60738823665, 3738.761430108],
    [0.00000000685, 0.38876148682, 15.252471185],
    [0.00000000601, 0.73489602442, 419.4846438752],
    [0.00000000716, 2.65279791438, 6309.3741697912],
    [0.00000000584, 5.54502568227, 17298.1823273262],
    [0.0000000065, 1.13379656406, 7058.5984613154],
    [0.00000000688, 2.59683891779, 3496.032826134],
    [0.00000000485, 0.44467180946, 12352.8526045448],
    [0.00000000528, 2.74936967681, 3930.2096962196],
    [0.00000000597, 5.27668281777, 10575.4066829418],
    [0.00000000583, 3.1892906781, 4732.0306273434],
    [0.00000000526, 5.01697321546, 5884.9268465832],
    [0.0000000054, 1.29175137075, 640.8776073822],
    [0.00000000473, 5.4995330697, 5230.807466803],
    [0.00000000406, 5.21248452189, 220.4126424388],
    [0.00000000395, 1.87474483222, 16200.7727245012],
    [0.0000000037, 3.84921354713, 18073.7049386502],
    [0.00000000367, 0.88533542778, 6283.14316029419],
    [0.00000000379, 0.37983009325, 10177.2576795336],
    [0.00000000356, 3.84145204913, 11712.9553182308],
    [0.00000000374, 5.01577520608, 7.046236698],
    [0.00000000381, 4.30250406634, 6062.6632075526],
    [0.00000000471, 0.86381834647, 6069.7767545534],
    [0.00000000367, 1.32943839763, 6283.0085396886],
    [0.0000000046, 5.19667219575, 6284.0561710596],
    [0.00000000333, 5.54256205741, 4686.8894077068],
    [0.00000000341, 4.36522989934, 7238.6755916],
    [0.00000000336, 4.00205876835, 3097.88382272579],
    [0.00000000359, 6.22679790284, 245.8316462294],
    [0.00000000307, 2.35299010924, 170.6728706192],
    [0.00000000343, 3.77164927143, 6076.8903015542],
    [0.00000000296, 5.44152227481, 17260.1546546904],
    [0.00000000328, 0.13837875384, 11015.1064773348],
    [0.00000000268, 1.1390455063, 12569.6748183318],
    [0.00000000263, 0.00538633678, 4136.9104335162],
    [0.00000000282, 5.0439983748, 7477.522860216],
    [0.00000000288, 3.13401177517, 12559.038152982],
    [0.00000000259, 0.93882269387, 5642.1982426092],
    [0.00000000292, 1.98420020514, 12132.439962106],
    [0.00000000247, 3.84244798532, 5429.8794682394],
    [0.00000000245, 5.70467521726, 65147.6197681377],
    [0.00000000241, 0.99480969552, 3634.6210245184],
    [0.00000000246, 3.06168069935, 110.2063212194],
    [0.00000000239, 6.11855909114, 11856.2186514245],
    [0.00000000263, 0.66348415419, 21228.3920235458],
    [0.00000000262, 1.51070507866, 12146.6670561076],
    [0.0000000023, 1.75927314884, 9779.1086761254],
    [0.00000000223, 2.00967043606, 6172.869528772],
    [0.00000000246, 1.10411690865, 6282.0955289232],
    [0.00000000221, 3.03945240854, 8635.9420037632],
    [0.00000000214, 4.03840869663, 14314.1681130498],
    [0.00000000236, 5.4691507058, 13916.0191096416],
    [0.00000000224, 4.68408089456, 24072.9214697764],
    [0.00000000212, 2.13695625494, 5849.3641121146],
    [0.00000000207, 3.07724246401, 11.729352836],
    [0.00000000207, 6.10306282747, 23543.23050468179],
    [0.00000000266, 1.00709566823, 2388.8940204492],
    [0.00000000217, 6.27837036335, 17267.26820169119],
    [0.00000000204, 2.34615348695, 266.6070417218],
    [0.00000000195, 5.55015549753, 6133.5126528568],
    [0.00000000188, 2.52667166175, 6525.8044539654],
    [0.00000000185, 0.90960768344, 18319.5365848796],
    [0.00000000177, 1.73429218289, 154717.60988768269],
    [0.00000000187, 4.76483647432, 4535.0594369244],
    [0.00000000186, 4.63080493407, 10440.2742926036],
    [0.00000000215, 2.8125545456, 7342.4577801806],
    [0.00000000172, 1.45551888559, 9225.539273283],
    [0.00000000162, 3.30661909388, 639.897286314],
    [0.00000000168, 2.17671416605, 27.4015560968],
    [0.0000000016, 1.68164180475, 15110.4661198662],
    [0.00000000158, 0.13519771874, 13095.8426650774],
    [0.00000000183, 0.56281322071, 13517.8701062334],
    [0.00000000179, 3.58450811616, 87.30820453981],
    [0.00000000152, 2.84070476818, 5650.2921106782],
    [0.00000000182, 0.44065530624, 17253.04110768959],
    [0.0000000016, 5.95767264171, 4701.1165017084],
    [0.00000000142, 1.4629013752, 11087.2851259184],
    [0.00000000142, 2.04464036087, 20426.571092422],
    [0.00000000131, 5.40912137746, 2699.7348193176],
    [0.00000000144, 2.07312090485, 25158.6017197654],
    [0.00000000147, 6.15106982168, 9623.6882766912],
    [0.00000000141, 5.55739979498, 10454.5013866052],
    [0.00000000135, 0.06098110407, 16723.350142595],
    [0.00000000124, 5.81218025669, 17256.6315363414],
    [0.00000000124, 2.36293551623, 4933.2084403326],
    [0.00000000126, 3.47435905118, 22483.84857449259],
    [0.00000000159, 5.63954754618, 5729.506447149],
    [0.00000000123, 3.92815963256, 17996.0311682222],
    [0.00000000148, 3.02509280598, 1551.045222648],
    [0.0000000012, 5.91904349732, 6206.8097787158],
    [0.00000000134, 3.11122937825, 21954.15760939799],
    [0.00000000119, 5.5214112345, 709.9330485583],
    [0.00000000122, 3.00813429479, 19800.9459562248],
    [0.00000000127, 1.37618620001, 14945.3161735544],
    [0.00000000141, 2.56889468729, 1052.2683831884],
    [0.00000000123, 2.83671175442, 11919.140866668],
    [0.00000000118, 0.81934438215, 5331.3574437408],
    [0.00000000151, 2.68731829165, 11769.8536931664],
    [0.00000000119, 5.08835797638, 5481.2549188676],
    [0.00000000153, 2.46021790779, 11933.3679606696],
    [0.00000000108, 1.04936452145, 11403.676995575],
    [0.00000000128, 0.99794735107, 8827.3902698748],
    [0.00000000144, 2.54869747042, 227.476132789],
    [0.0000000015, 4.50631437136, 2379.1644735716],
    [0.00000000107, 1.79272017026, 13119.72110282519],
    [0.00000000107, 4.43556814486, 18422.62935909819],
    [0.00000000109, 0.29269062317, 16737.5772365966],
    [0.00000000141, 3.18979826258, 6262.300454499],
    [0.00000000122, 4.23040027813, 29.429508536],
    [0.00000000111, 5.16954029551, 17782.7320727842],
    [0.000000001, 3.52213872761, 18052.9295431578],
    [0.00000000108, 1.08514212991, 16858.4825329332],
    [0.00000000106, 1.9608524841, 74.7815985673],
    [0.0000000011, 2.30582372873, 16460.33352952499],
    [0.00000000097, 3.5091894021, 5333.9002410216],
    [0.00000000099, 3.56417337974, 735.8765135318],
    [0.00000000094, 5.01857894228, 3128.3887650958],
    [0.00000000097, 1.65579893894, 533.2140834436],
    [0.00000000092, 0.89217162285, 29296.6153895786],
    [0.00000000123, 3.16062050433, 9380.9596727172],
    [0.00000000102, 1.20493500565, 23020.65308658799],
    [0.00000000088, 2.21296088224, 12721.572099417],
    [0.00000000089, 1.5426472031, 20199.094959633],
    [0.00000000113, 4.8332070787, 16496.3613962024],
    [0.00000000121, 6.19860353182, 9388.0059094152],
    [0.00000000089, 4.08082274765, 22805.7355659936],
    [0.00000000098, 1.0918183283, 12043.574281889],
    [0.00000000086, 1.13655027605, 143571.32428481648],
    [0.00000000088, 5.96980472191, 107.6635239386],
    [0.00000000082, 5.01340404594, 22003.9146348698],
    [0.00000000094, 1.69615700473, 23006.42599258639],
    [0.00000000081, 3.00657814365, 2118.7638603784],
    [0.00000000098, 1.39215287161, 8662.240323563],
    [0.00000000077, 3.3355519084, 15720.8387848784],
    [0.00000000082, 5.86880116464, 2787.0430238574],
    [0.00000000076, 5.67183650604, 14.2270940016],
    [0.00000000081, 6.16619455699, 1039.0266107904],
    [0.00000000076, 3.21449884756, 111.1866422876],
    [0.00000000078, 1.37531518377, 21947.1113727],
    [0.00000000074, 3.58814195051, 11609.8625440122],
    [0.00000000077, 4.84846488388, 22743.4093795164],
    [0.0000000009, 1.48869013606, 15671.0817594066],
    [0.00000000082, 3.48618399109, 29088.811415985],
    [0.00000000069, 3.55746476593, 4590.910180489],
    [0.00000000069, 1.93625656075, 135.62532501],
    [0.0000000007, 2.66548322237, 18875.525869774],
    [0.00000000069, 5.41478093731, 26735.9452622132],
    [0.00000000079, 5.15154513662, 12323.4230960088],
    [0.00000000094, 3.62899392448, 77713.7714681205],
    [0.00000000078, 4.17011182047, 1066.49547719],
    [0.00000000071, 3.89435637865, 22779.4372461938],
    [0.00000000063, 4.53968787714, 8982.810669309],
    [0.00000000069, 0.96028230548, 14919.0178537546],
    [0.00000000076, 3.29092216589, 2942.4634232916],
    [0.00000000063, 4.09167842893, 16062.1845261168],
    [0.00000000065, 3.34580407184, 51.28033786241],
    [0.00000000065, 5.75757544877, 52670.0695933026],
    [0.00000000068, 5.75884067555, 21424.4666443034],
    [0.00000000057, 5.4512239985, 12592.4500197826],
    [0.00000000057, 5.25043362558, 20995.3929664494],
    [0.00000000073, 0.53299090807, 2301.58581590939],
    [0.0000000007, 4.31243357502, 19402.7969528166],
    [0.00000000067, 2.53852336668, 377.3736079158],
    [0.00000000056, 3.20816844695, 24889.5747959916],
    [0.00000000053, 3.17816599142, 18451.07854656599],
    [0.00000000053, 3.61529270216, 77.673770428],
    [0.00000000053, 0.45467549335, 30666.1549584328],
    [0.00000000061, 0.14807288453, 23013.5395395872],
    [0.00000000051, 3.32803972907, 56.8983749356],
    [0.00000000052, 3.41177624177, 23141.5583829246],
    [0.00000000058, 3.13638677202, 309.2783226558],
    [0.0000000007, 2.50592323465, 31415.379249957],
    [0.00000000052, 5.10673376738, 17796.9591667858],
    [0.00000000067, 6.27917920454, 22345.2603761082],
    [0.0000000005, 0.42577644151, 25685.872802808],
    [0.00000000048, 0.70204553333, 1162.4747044078],
    [0.00000000066, 3.64350022359, 15265.8865193004],
    [0.0000000005, 5.7438291744, 19.66976089979],
    [0.0000000005, 4.69825387775, 28237.2334593894],
    [0.00000000047, 5.74015846442, 12139.5535091068],
    [0.00000000054, 1.97301333704, 23581.2581773176],
    [0.00000000049, 4.98223579027, 10021.8372800994],
    [0.00000000046, 5.41431705539, 33019.0211122046],
    [0.00000000051, 1.23882053879, 12539.853380183],
    [0.00000000046, 2.41369976086, 98068.53671630539],
    [0.00000000044, 0.80750593746, 167283.76158766549],
    [0.00000000045, 4.39613584445, 433.7117378768],
    [0.00000000044, 2.57358208785, 12964.300703391],
    [0.00000000046, 0.26142733448, 11.0457002639],
    [0.00000000045, 2.46230645202, 51868.2486621788],
    [0.00000000048, 0.89551707131, 56600.2792895222],
    [0.00000000057, 1.8641670701, 25287.7237993998],
    [0.00000000042, 5.26377513431, 26084.0218062162],
    [0.00000000049, 3.17757670611, 6303.8512454838],
    [0.00000000052, 3.65266055509, 7872.1487452752],
    [0.0000000004, 1.81891629936, 34596.3646546524],
    [0.00000000043, 1.94164978061, 1903.4368125012],
    [0.00000000041, 0.74461854136, 23937.856389741],
    [0.00000000048, 6.26034008181, 28286.9904848612],
    [0.00000000045, 5.4557501753, 60530.4889857418],
    [0.0000000004, 2.92105728682, 21548.9623692918],
    [0.0000000004, 0.04502010161, 38526.574350872],
    [0.00000000053, 3.64791042082, 11925.2740926006],
    [0.00000000041, 5.04048954693, 27832.0382192832],
    [0.00000000042, 5.19292937193, 19004.6479494084],
    [0.0000000004, 2.57120233428, 24356.7807886416],
    [0.00000000038, 3.49190341464, 226858.23855437008],
    [0.00000000039, 4.61184303844, 95.9792272178],
    [0.00000000043, 2.20648228147, 13521.7514415914],
    [0.0000000004, 5.83461945819, 16193.65917750039],
    [0.00000000045, 3.73714372195, 7875.6718636242],
    [0.00000000043, 1.14078465002, 49.7570254718],
    [0.00000000037, 1.29390383811, 310.8407988684],
    [0.00000000038, 0.9597092595, 664.75604513],
    [0.00000000037, 4.27532649462, 6709.6740408674],
    [0.00000000038, 2.20108541046, 28628.3362260996],
    [0.00000000039, 0.85957361635, 16522.6597160022],
    [0.0000000004, 4.35214003837, 48739.859897083],
    [0.00000000036, 1.68167662194, 10344.2950653858],
    [0.0000000004, 5.13217319067, 15664.03552270859],
    [0.00000000036, 3.72187132496, 30774.5016425748],
    [0.00000000036, 3.32158458257, 16207.886271502],
    [0.00000000045, 3.94202418608, 10988.808157535],
    [0.00000000039, 1.51948786199, 12029.3471878874],
    [0.00000000026, 3.8768588318, 6262.7205305926],
    [0.00000000024, 4.91804163466, 19651.048481098],
    [0.00000000023, 0.29300197709, 13362.4497067992],
    [0.00000000021, 3.18605672363, 6277.552925684],
    [0.00000000021, 6.07546891132, 18139.2945014159],
    [0.00000000022, 2.31199937177, 6303.4311693902],
    [0.00000000021, 3.58418394393, 18209.33026366019],
    [0.00000000026, 2.068012969, 12573.2652469836],
    [0.00000000021, 1.56857722317, 13341.6743113068],
    [0.00000000024, 5.72605158675, 29864.334027309],
    [0.00000000024, 1.40237993205, 14712.317116458],
    [0.00000000025, 5.71466092822, 25934.1243310894],
];

const VSOP87_L2: Vsop87Element = [
    [0.0005291887],
    [0.00008719837, 1.07209665242, 6283.0758499914],
    [0.00000309125, 0.86728818832, 12566.1516999828],
    [0.00000027339, 0.05297871691, 3.523118349],
    [0.00000016334, 5.18826691036, 26.2983197998],
    [0.00000015752, 3.6845788943, 155.4203994342],
    [0.00000009541, 0.75742297675, 18849.2275499742],
    [0.00000008937, 2.05705419118, 77713.7714681205],
    [0.00000006952, 0.8267330541, 775.522611324],
    [0.00000005064, 4.66284525271, 1577.3435424478],
    [0.00000004061, 1.03057162962, 7.1135470008],
    [0.00000003463, 5.14074632811, 796.2980068164],
    [0.00000003169, 6.05291851171, 5507.5532386674],
    [0.0000000302, 1.19246506441, 242.728603974],
    [0.00000002886, 6.11652627155, 529.6909650946],
    [0.0000000381, 3.4405080349, 5573.1428014331],
    [0.00000002714, 0.30637881025, 398.1490034082],
    [0.00000002371, 4.38118838167, 5223.6939198022],
    [0.00000002538, 2.27992810679, 553.5694028424],
    [0.00000002079, 3.75435330484, 0.9803210682],
    [0.00000001675, 0.90216407959, 951.7184062506],
    [0.00000001534, 5.75900462759, 1349.8674096588],
    [0.00000001224, 2.97328088405, 2146.1654164752],
    [0.00000001449, 4.3641591397, 1748.016413067],
    [0.00000001341, 3.72061130861, 1194.4470102246],
    [0.00000001254, 2.94846826628, 6438.4962494256],
    [0.00000000999, 5.98640014468, 6286.5989683404],
    [0.00000000917, 4.79788687522, 5088.6288397668],
    [0.00000000828, 3.31321076572, 213.299095438],
    [0.00000001103, 1.27104454479, 161000.6857376741],
    [0.00000000762, 3.41582762988, 5486.777843175],
    [0.00000001044, 0.60409577691, 3154.6870848956],
    [0.00000000887, 5.23465144638, 7084.8967811152],
    [0.00000000645, 1.60096192515, 2544.3144198834],
    [0.00000000681, 3.43155669169, 4694.0029547076],
    [0.00000000605, 2.47806340546, 10977.078804699],
    [0.00000000706, 6.19393222575, 4690.4798363586],
    [0.00000000643, 1.98042503148, 801.8209311238],
    [0.00000000502, 1.44394375363, 6836.6452528338],
    [0.0000000049, 2.34129524194, 1592.5960136328],
    [0.00000000458, 1.30876448575, 4292.3308329504],
    [0.00000000431, 0.03526421494, 7234.794256242],
    [0.00000000379, 3.17030522615, 6309.3741697912],
    [0.00000000348, 0.99049550009, 6040.3472460174],
    [0.00000000386, 1.57019797263, 71430.69561812909],
    [0.00000000347, 0.67013291338, 1059.3819301892],
    [0.00000000458, 3.81499443681, 149854.40013480789],
    [0.00000000302, 1.91760044838, 10447.3878396044],
    [0.00000000307, 3.55343347416, 8031.0922630584],
    [0.00000000395, 4.93701776616, 7632.9432596502],
    [0.00000000314, 3.18093696547, 2352.8661537718],
    [0.00000000282, 4.41936437052, 9437.762934887],
    [0.00000000276, 2.71314254553, 3894.1818295422],
    [0.00000000298, 2.5203747421, 6127.6554505572],
    [0.0000000023, 1.37790215549, 4705.7323075436],
    [0.00000000252, 0.55330133471, 6279.5527316424],
    [0.00000000255, 5.26570187369, 6812.766815086],
    [0.00000000275, 0.67264264272, 25132.3033999656],
    [0.00000000178, 0.92820785174, 1990.745017041],
    [0.00000000221, 0.63897368842, 6256.7775301916],
    [0.00000000155, 0.77319790838, 14143.4952424306],
    [0.0000000015, 2.40470465561, 426.598190876],
    [0.00000000196, 6.06877865012, 640.8776073822],
    [0.00000000137, 2.21679460145, 8429.2412664666],
    [0.00000000127, 3.26094223174, 17789.845619785],
    [0.00000000128, 5.47237279946, 12036.4607348882],
    [0.00000000122, 2.16291082757, 10213.285546211],
    [0.00000000118, 0.45789822268, 7058.5984613154],
    [0.00000000141, 2.34932647403, 11506.7697697936],
    [0.000000001, 0.85621569847, 6290.1893969922],
    [0.00000000092, 5.10587476002, 7079.3738568078],
    [0.00000000126, 2.65428307012, 88860.05707098669],
    [0.00000000106, 5.85646710022, 7860.4193924392],
    [0.00000000084, 3.57457554262, 16730.4636895958],
    [0.00000000089, 4.21433259618, 83996.84731811189],
    [0.00000000097, 5.57938280855, 13367.9726311066],
    [0.00000000102, 2.05853060226, 87.30820453981],
    [0.0000000008, 4.73792651816, 11926.2544136688],
    [0.0000000008, 5.41418965044, 10973.55568635],
    [0.00000000106, 4.10978997399, 3496.032826134],
    [0.00000000102, 3.62650006043, 244287.60000722769],
    [0.00000000075, 4.89483161769, 5643.1785636774],
    [0.00000000087, 0.42863750683, 11015.1064773348],
    [0.00000000069, 1.8890876072, 10177.2576795336],
    [0.00000000089, 1.35567273119, 6681.2248533996],
    [0.00000000066, 0.99455837265, 6525.8044539654],
    [0.00000000067, 5.5124099707, 3097.88382272579],
    [0.00000000076, 2.72016814799, 4164.311989613],
    [0.00000000063, 1.4434990254, 9917.6968745098],
    [0.00000000078, 3.51469733747, 11856.2186514245],
    [0.00000000085, 0.50956043858, 10575.4066829418],
    [0.00000000067, 3.62043033405, 16496.3613962024],
    [0.00000000055, 5.24637517308, 3340.6124266998],
    [0.00000000048, 5.43966777314, 20426.571092422],
    [0.00000000064, 5.79535817813, 2388.8940204492],
    [0.00000000046, 5.43499966519, 6275.9623029906],
    [0.0000000005, 3.86263598617, 5729.506447149],
    [0.00000000044, 1.52269529228, 12168.0026965746],
    [0.00000000057, 4.96352373486, 14945.3161735544],
    [0.00000000045, 1.0086123016, 8635.9420037632],
    [0.00000000043, 3.30685683359, 9779.1086761254],
    [0.00000000042, 0.6348125893, 2699.7348193176],
    [0.00000000041, 5.67996766641, 11712.9553182308],
    [0.00000000056, 4.34024451468, 90955.5516944961],
    [0.00000000041, 5.81722212845, 709.9330485583],
    [0.00000000053, 6.17052087143, 233141.31440436149],
    [0.00000000037, 3.12495025087, 16200.7727245012],
    [0.00000000035, 5.76973458495, 12569.6748183318],
    [0.00000000037, 0.31656444326, 24356.7807886416],
    [0.00000000035, 0.96229051027, 17298.1823273262],
    [0.00000000033, 5.23130355867, 5331.3574437408],
    [0.00000000035, 0.62517020593, 25158.6017197654],
    [0.00000000035, 0.80004512129, 13916.0191096416],
    [0.00000000037, 2.89336088688, 12721.572099417],
    [0.0000000003, 4.50198402401, 23543.23050468179],
    [0.0000000003, 5.31355708693, 18319.5365848796],
    [0.00000000029, 3.47275229977, 13119.72110282519],
    [0.00000000029, 3.11002782516, 4136.9104335162],
    [0.00000000032, 5.52273255667, 5753.3848848968],
    [0.00000000035, 3.7969999668, 143571.32428481648],
    [0.00000000026, 1.50634201907, 154717.60988768269],
    [0.0000000003, 3.53519084118, 6284.0561710596],
    [0.00000000023, 4.41808025967, 5884.9268465832],
    [0.00000000025, 1.38477355808, 65147.6197681377],
    [0.00000000023, 3.49782549797, 7477.522860216],
    [0.00000000019, 3.14329413716, 6496.3749454294],
    [0.00000000019, 2.20135125199, 18073.7049386502],
    [0.00000000019, 4.95020255309, 3930.2096962196],
    [0.00000000019, 0.57998702747, 31415.379249957],
    [0.00000000021, 1.75474323399, 12139.5535091068],
    [0.00000000019, 3.92233070499, 19651.048481098],
    [0.00000000014, 0.98131213224, 12559.038152982],
    [0.00000000019, 4.93309333729, 2942.4634232916],
    [0.00000000016, 5.55997534558, 8827.3902698748],
    [0.00000000013, 1.68808165516, 4535.0594369244],
    [0.00000000013, 0.33982116161, 4933.2084403326],
    [0.00000000012, 1.85426309994, 5856.4776591154],
    [0.0000000001, 4.82763996845, 13095.8426650774],
    [0.00000000011, 5.38005490571, 11790.6290886588],
    [0.0000000001, 1.40815507226, 10988.808157535],
    [0.00000000011, 3.05005267431, 17260.1546546904],
    [0.0000000001, 4.93364992366, 12352.8526045448],
];

const VSOP87_L3: Vsop87Element = [
    [0.00000289226, 5.84384198723, 6283.0758499914],
    [0.00000034955],
    [0.00000016819, 5.48766912348, 12566.1516999828],
    [0.00000002962, 5.19577265202, 155.4203994342],
    [0.00000001288, 4.72200252235, 3.523118349],
    [0.00000000635, 5.96925937141, 242.728603974],
    [0.00000000714, 5.30045809128, 18849.2275499742],
    [0.00000000402, 3.78682982419, 553.5694028424],
    [0.00000000072, 4.2976812618, 6286.5989683404],
    [0.00000000067, 0.90721687647, 6127.6554505572],
    [0.00000000036, 5.24029648014, 6438.4962494256],
    [0.00000000024, 5.16003960716, 25132.3033999656],
    [0.00000000023, 3.01921570335, 6309.3741697912],
    [0.00000000017, 5.82863573502, 6525.8044539654],
    [0.00000000017, 3.6777286393, 71430.69561812909],
    [0.00000000009, 4.58467294499, 1577.3435424478],
    [0.00000000008, 1.40626662824, 11856.2186514245],
    [0.00000000008, 5.07561257196, 6256.7775301916],
    [0.00000000007, 2.82473374405, 83996.84731811189],
    [0.00000000005, 2.71488713339, 10977.078804699],
    [0.00000000005, 3.76879847273, 12036.4607348882],
    [0.00000000005, 4.28412873331, 6275.9623029906],
];

const VSOP87_L4: Vsop87Element = [
    [0.00000114084, Math.PI],
    [0.00000007717, 4.13446589358, 6283.0758499914],
    [0.00000000765, 3.83803776214, 12566.1516999828],
    [0.0000000042, 0.41925861858, 155.4203994342],
    [0.0000000004, 3.5984758584, 18849.2275499742],
    [0.00000000041, 3.14398414077, 3.523118349],
    [0.00000000035, 5.00298940826, 5573.1428014331],
    [0.00000000013, 0.48794833701, 77713.7714681205],
    [0.0000000001, 5.6480176635, 6127.6554505572],
    [0.00000000008, 2.84160570605, 161000.6857376741],
    [0.00000000002, 0.54912904658, 6438.4962494256],
];

const VSOP87_L5: Vsop87Element = [
    [0.00000000878, Math.PI],
    [0.00000000172, 2.7657906951, 6283.0758499914],
    [0.0000000005, 2.01353298182, 155.4203994342],
    [0.00000000028, 2.21496423926, 12566.1516999828],
    [0.00000000005, 1.75600058765, 18849.2275499742],
];

const VSOP87_B0: Vsop87Element = [
    [0.0000027962, 3.19870156017, 84334.66158130829],
    [0.00000101643, 5.42248619256, 5507.5532386674],
    [0.00000080445, 3.88013204458, 5223.6939198022],
    [0.00000043806, 3.70444689758, 2352.8661537718],
    [0.00000031933, 4.00026369781, 1577.3435424478],
    [0.00000022724, 3.9847383156, 1047.7473117547],
    [0.00000016392, 3.56456119782, 5856.4776591154],
    [0.00000018141, 4.98367470263, 6283.0758499914],
    [0.00000014443, 3.70275614914, 9437.762934887],
    [0.00000014304, 3.41117857525, 10213.285546211],
    [0.00000011246, 4.8282069053, 14143.4952424306],
    [0.000000109, 2.08574562327, 6812.766815086],
    [0.00000009714, 3.47303947752, 4694.0029547076],
    [0.00000010367, 4.05663927946, 71092.88135493269],
    [0.00000008775, 4.44016515669, 5753.3848848968],
    [0.00000008366, 4.9925151218, 7084.8967811152],
    [0.00000006921, 4.32559054073, 6275.9623029906],
    [0.00000009145, 1.14182646613, 6620.8901131878],
    [0.00000007194, 3.60193205752, 529.6909650946],
    [0.00000007698, 5.55425745881, 167621.57585086189],
    [0.00000005285, 2.48446991566, 4705.7323075436],
    [0.00000005208, 6.24992674537, 18073.7049386502],
    [0.00000004529, 2.33827747356, 6309.3741697912],
    [0.00000005579, 4.41023653738, 7860.4193924392],
    [0.00000004743, 0.70995680136, 5884.9268465832],
    [0.00000004301, 1.10255777773, 6681.2248533996],
    [0.00000003849, 1.82229412531, 5486.777843175],
    [0.00000004093, 5.11700141207, 13367.9726311066],
    [0.00000003681, 0.43793170356, 3154.6870848956],
    [0.0000000342, 5.42034800952, 6069.7767545534],
    [0.00000003617, 6.04641937526, 3930.2096962196],
    [0.0000000367, 4.58210192227, 12194.0329146209],
    [0.00000002918, 1.95463881126, 10977.078804699],
    [0.00000002797, 5.61259275048, 11790.6290886588],
    [0.00000002502, 0.60499729367, 6496.3749454294],
    [0.00000002319, 5.01648216014, 1059.3819301892],
    [0.00000002684, 1.39470396488, 22003.9146348698],
    [0.00000002428, 3.24183056052, 78051.5857313169],
    [0.0000000212, 4.30691000285, 5643.1785636774],
    [0.00000002257, 3.15557225618, 90617.7374312997],
    [0.00000001813, 3.75574218285, 3340.6124266998],
    [0.00000002226, 2.79699346659, 12036.4607348882],
    [0.00000001888, 0.86991545823, 8635.9420037632],
    [0.00000001517, 1.95852055701, 398.1490034082],
    [0.00000001581, 3.19976230948, 5088.6288397668],
    [0.00000001421, 6.25530883827, 2544.3144198834],
    [0.00000001595, 0.25619915135, 17298.1823273262],
    [0.00000001391, 4.69964175561, 7058.5984613154],
    [0.00000001478, 2.81808207569, 25934.1243310894],
    [0.00000001481, 3.65823554806, 11506.7697697936],
    [0.00000001693, 4.95689385293, 156475.2902479957],
    [0.00000001183, 1.29343061246, 775.522611324],
    [0.00000001114, 2.37889311846, 3738.761430108],
    [0.00000000994, 4.30088900425, 9225.539273283],
    [0.00000000924, 3.06451026812, 4164.311989613],
    [0.00000000867, 0.55606931068, 8429.2412664666],
    [0.00000000988, 5.97286104208, 7079.3738568078],
    [0.00000000824, 1.50984806173, 10447.3878396044],
    [0.00000000915, 0.12635654592, 11015.1064773348],
    [0.00000000742, 1.99159139281, 26087.9031415742],
    [0.00000001039, Math.PI],
    [0.0000000085, 4.24120016095, 29864.334027309],
    [0.00000000755, 2.8963187332, 4732.0306273434],
    [0.00000000714, 1.37548118603, 2146.1654164752],
    [0.00000000708, 1.91406542362, 8031.0922630584],
    [0.00000000746, 0.57893808616, 796.2980068164],
    [0.00000000802, 5.1233913723, 2942.4634232916],
    [0.00000000751, 1.67479850166, 21228.3920235458],
    [0.00000000602, 4.09976538826, 64809.80550494129],
    [0.00000000594, 3.49580704962, 16496.3613962024],
    [0.00000000592, 4.59481504319, 4690.4798363586],
    [0.0000000053, 5.739792952, 8827.3902698748],
    [0.00000000503, 5.66433137112, 33794.5437235286],
    [0.00000000483, 1.57106522411, 801.8209311238],
    [0.00000000438, 0.06707733767, 3128.3887650958],
    [0.00000000423, 2.86944595927, 12566.1516999828],
    [0.00000000504, 3.2620766916, 7632.9432596502],
    [0.00000000552, 1.02926440457, 239762.20451754928],
    [0.00000000427, 3.6743437821, 213.299095438],
    [0.00000000404, 1.46193297142, 15720.8387848784],
    [0.00000000503, 4.85802444134, 6290.1893969922],
    [0.00000000417, 0.81920713533, 5216.5803728014],
    [0.00000000365, 0.01002966162, 12168.0026965746],
    [0.00000000363, 1.28376436579, 6206.8097787158],
    [0.00000000353, 4.7005913311, 7234.794256242],
    [0.00000000415, 0.96862624175, 4136.9104335162],
    [0.00000000387, 3.09145061418, 25158.6017197654],
    [0.00000000373, 2.65119262792, 7342.4577801806],
    [0.00000000361, 2.97762937739, 9623.6882766912],
    [0.00000000418, 3.75759994446, 5230.807466803],
    [0.00000000396, 1.22507712354, 6438.4962494256],
    [0.00000000322, 1.21162178805, 8662.240323563],
    [0.00000000284, 5.64170320068, 1589.0728952838],
    [0.00000000379, 1.72248432748, 14945.3161735544],
    [0.0000000032, 3.94161159962, 7330.8231617461],
    [0.00000000313, 5.47602376446, 1194.4470102246],
    [0.00000000292, 1.38971327603, 11769.8536931664],
    [0.00000000305, 0.80429352049, 37724.7534197482],
    [0.00000000257, 5.81382809757, 426.598190876],
    [0.00000000265, 6.10358507671, 6836.6452528338],
    [0.0000000025, 4.56452895547, 7477.522860216],
    [0.00000000266, 2.62926282354, 7238.6755916],
    [0.00000000263, 6.22089501237, 6133.5126528568],
    [0.00000000306, 2.79682380531, 1748.016413067],
    [0.00000000236, 2.46093023714, 11371.7046897582],
    [0.00000000316, 1.62662805006, 250908.49012041549],
    [0.00000000216, 3.68721275185, 5849.3641121146],
    [0.0000000023, 0.36165162947, 5863.5912061162],
    [0.00000000233, 5.03509933858, 20426.571092422],
    [0.000000002, 5.86073159059, 4535.0594369244],
    [0.00000000277, 4.65400292395, 82239.16695779889],
    [0.00000000209, 3.72323200804, 10973.55568635],
    [0.00000000199, 5.05186622555, 5429.8794682394],
    [0.00000000256, 2.4092327977, 19651.048481098],
    [0.0000000021, 4.50691909144, 29088.811415985],
    [0.00000000181, 6.00294783127, 4292.3308329504],
    [0.00000000249, 0.12900984422, 154379.79562448629],
    [0.00000000209, 3.87759458598, 17789.845619785],
    [0.00000000225, 3.18339652605, 18875.525869774],
    [0.00000000191, 4.53897489299, 18477.1087646123],
    [0.00000000172, 2.09694183014, 13095.8426650774],
    [0.00000000182, 3.161079435, 16730.4636895958],
    [0.00000000188, 2.22746128596, 41654.9631159678],
    [0.00000000164, 5.18686275017, 5481.2549188676],
    [0.0000000016, 2.49298855159, 12592.4500197826],
    [0.00000000155, 1.5959543823, 10021.8372800994],
    [0.00000000135, 0.21349051064, 10988.808157535],
    [0.00000000178, 3.8037517797, 23581.2581773176],
    [0.00000000123, 1.66800739151, 15110.4661198662],
    [0.00000000122, 2.72678272244, 18849.2275499742],
    [0.00000000126, 1.1767551291, 14919.0178537546],
    [0.00000000142, 3.95053441332, 337.8142631964],
    [0.00000000116, 6.06340906229, 6709.6740408674],
    [0.00000000137, 3.52143246757, 12139.5535091068],
    [0.00000000136, 2.92179113542, 32217.2001810808],
    [0.0000000011, 3.51203379263, 18052.9295431578],
    [0.00000000147, 4.63371971408, 22805.7355659936],
    [0.00000000108, 5.45280814878, 7.1135470008],
    [0.00000000148, 0.65447253687, 95480.9471841745],
    [0.00000000119, 5.92110458985, 33019.0211122046],
    [0.0000000011, 5.34824206306, 639.897286314],
    [0.00000000106, 3.71081682629, 14314.1681130498],
    [0.00000000139, 6.17607198418, 24356.7807886416],
    [0.00000000118, 5.5973871267, 161338.5000008705],
    [0.00000000117, 3.6506527164, 45585.1728121874],
    [0.00000000127, 4.74596574209, 49515.382508407],
    [0.0000000012, 1.04211499785, 6915.8595893046],
    [0.0000000012, 5.60638811846, 5650.2921106782],
    [0.00000000115, 3.10668213289, 14712.317116458],
    [0.00000000099, 0.69018940049, 12779.4507954208],
    [0.00000000097, 1.07908724794, 9917.6968745098],
    [0.00000000093, 2.62295197319, 17260.1546546904],
    [0.00000000099, 4.45774681732, 4933.2084403326],
    [0.00000000123, 1.37488922089, 28286.9904848612],
    [0.00000000121, 5.19767249813, 27511.4678735372],
    [0.00000000105, 0.87192267806, 77375.95720492408],
    [0.00000000087, 3.9363781295, 17654.7805397496],
    [0.00000000122, 2.2395606868, 83997.09113559539],
    [0.00000000087, 4.18201600952, 22779.4372461938],
    [0.00000000104, 4.59580877295, 1349.8674096588],
    [0.00000000102, 2.83545248411, 12352.8526045448],
    [0.00000000102, 3.97386522171, 10818.1352869158],
    [0.00000000101, 4.32892825857, 36147.4098773004],
    [0.00000000094, 5.00001709261, 150192.21439800429],
    [0.00000000077, 3.97199369296, 1592.5960136328],
    [0.000000001, 6.07733097102, 26735.9452622132],
    [0.00000000086, 5.2602963825, 28313.288804661],
    [0.00000000093, 4.31900620254, 44809.6502008634],
    [0.00000000076, 6.22743405935, 13521.7514415914],
    [0.00000000072, 1.55820597747, 6256.7775301916],
    [0.00000000082, 4.95202664555, 10575.4066829418],
    [0.00000000082, 1.69647647075, 1990.745017041],
    [0.00000000075, 2.29836095644, 3634.6210245184],
    [0.00000000075, 2.66367876557, 16200.7727245012],
    [0.00000000087, 0.26630214764, 31441.6775697568],
    [0.00000000077, 2.25530954137, 5235.3285382367],
    [0.00000000076, 1.09869730846, 12903.9659631792],
    [0.00000000058, 4.28246138307, 12559.038152982],
    [0.00000000064, 5.51112830114, 173904.65170085328],
    [0.00000000056, 2.60133794851, 73188.3759784421],
    [0.00000000055, 5.81483150022, 143233.51002162008],
    [0.00000000054, 3.38482031504, 323049.11878710288],
    [0.00000000039, 3.28500401343, 71768.50988132549],
    [0.00000000039, 3.1123991069, 96900.81328129109],
];

const VSOP87_B1: Vsop87Element = [
    [0.0000000903, 3.8972906189, 5507.5532386674],
    [0.00000006177, 1.73038850355, 5223.6939198022],
    [0.000000038, 5.24404145734, 2352.8661537718],
    [0.00000002834, 2.4734503745, 1577.3435424478],
    [0.00000001817, 0.41874743765, 6283.0758499914],
    [0.00000001499, 1.83320979291, 5856.4776591154],
    [0.00000001466, 5.69401926017, 5753.3848848968],
    [0.00000001301, 2.18890066314, 9437.762934887],
    [0.00000001233, 4.95222451476, 10213.285546211],
    [0.00000001021, 0.12866660208, 7860.4193924392],
    [0.00000000982, 0.09005453285, 14143.4952424306],
    [0.00000000865, 1.73949953555, 3930.2096962196],
    [0.00000000581, 2.26949174067, 5884.9268465832],
    [0.00000000524, 5.65662503159, 529.6909650946],
    [0.00000000473, 6.22750969242, 6309.3741697912],
    [0.00000000451, 1.53288619213, 18073.7049386502],
    [0.00000000364, 3.61614477374, 13367.9726311066],
    [0.00000000372, 3.2247072132, 6275.9623029906],
    [0.00000000268, 2.34341267879, 11790.6290886588],
    [0.00000000322, 0.94084045832, 6069.7767545534],
    [0.00000000232, 0.26781182579, 7058.5984613154],
    [0.00000000216, 6.05952221329, 10977.078804699],
    [0.00000000232, 2.93325646109, 22003.9146348698],
    [0.00000000204, 3.86264841382, 6496.3749454294],
    [0.00000000202, 2.81892511133, 15720.8387848784],
    [0.00000000185, 4.93512381859, 12036.4607348882],
    [0.0000000022, 3.99305643742, 6812.766815086],
    [0.00000000166, 1.74970002999, 11506.7697697936],
    [0.00000000212, 1.57166285369, 4694.0029547076],
    [0.00000000157, 1.08259734788, 5643.1785636774],
    [0.00000000154, 5.99434678412, 5486.777843175],
    [0.00000000144, 5.23285656085, 78051.5857313169],
    [0.00000000144, 1.16454655948, 90617.7374312997],
    [0.00000000137, 2.67760436027, 6290.1893969922],
    [0.0000000018, 2.06509026215, 7084.8967811152],
    [0.00000000121, 5.90212574947, 9225.539273283],
    [0.0000000015, 2.00175038718, 5230.807466803],
    [0.00000000149, 5.06157254516, 17298.1823273262],
    [0.00000000118, 5.39979058038, 3340.6124266998],
    [0.00000000161, 3.32421999691, 6283.3196674749],
    [0.00000000121, 4.36722193162, 19651.048481098],
    [0.00000000116, 5.83462858507, 4705.7323075436],
    [0.00000000128, 4.35489873365, 25934.1243310894],
    [0.00000000143],
    [0.00000000109, 2.52157834166, 6438.4962494256],
    [0.00000000099, 2.70727488041, 5216.5803728014],
    [0.00000000103, 0.93782340879, 8827.3902698748],
    [0.00000000082, 4.2921468039, 8635.9420037632],
    [0.00000000079, 2.24085737326, 1059.3819301892],
    [0.00000000097, 5.50959692365, 29864.334027309],
    [0.00000000072, 0.21891639822, 21228.3920235458],
    [0.00000000071, 2.86755026812, 6681.2248533996],
    [0.00000000074, 2.20184828895, 37724.7534197482],
    [0.00000000063, 4.45586625948, 7079.3738568078],
    [0.00000000061, 0.63918772258, 33794.5437235286],
    [0.00000000047, 2.09070235724, 3128.3887650958],
    [0.00000000047, 3.325438433, 26087.9031415742],
    [0.00000000049, 1.60680905005, 6702.5604938666],
    [0.00000000057, 0.11215813438, 29088.811415985],
    [0.00000000056, 5.47982934911, 775.522611324],
    [0.0000000005, 1.89396788463, 12139.5535091068],
    [0.00000000047, 2.9721490724, 20426.571092422],
    [0.00000000041, 5.5532939489, 11015.1064773348],
    [0.00000000041, 5.91861144924, 23581.2581773176],
    [0.00000000045, 4.95273290181, 5863.5912061162],
    [0.0000000005, 3.62740835096, 41654.9631159678],
    [0.00000000037, 6.09033460601, 64809.80550494129],
    [0.00000000037, 5.86153655431, 12566.1516999828],
    [0.00000000046, 1.65798680284, 25158.6017197654],
    [0.00000000038, 2.00673650251, 426.598190876],
    [0.00000000036, 6.24373396652, 6283.14316029419],
    [0.00000000036, 0.40465162918, 6283.0085396886],
    [0.00000000032, 6.03707103538, 2942.4634232916],
    [0.00000000041, 4.86809570283, 1592.5960136328],
    [0.00000000028, 4.38359423735, 7632.9432596502],
    [0.00000000028, 6.03334294232, 17789.845619785],
    [0.00000000026, 3.88971333608, 5331.3574437408],
    [0.00000000026, 5.94932724051, 16496.3613962024],
    [0.00000000031, 1.44666331503, 16730.4636895958],
    [0.00000000026, 6.26376705837, 23543.23050468179],
    [0.00000000033, 0.93797239147, 213.299095438],
    [0.00000000026, 3.71858432944, 13095.8426650774],
    [0.00000000027, 0.60565274405, 10988.808157535],
    [0.00000000023, 4.4438898555, 18849.2275499742],
    [0.00000000028, 1.53862289477, 6279.4854213396],
    [0.00000000028, 1.96831814872, 6286.6662786432],
    [0.00000000028, 5.78094918529, 15110.4661198662],
    [0.00000000026, 2.48165809843, 5729.506447149],
    [0.0000000002, 3.85655029499, 9623.6882766912],
    [0.00000000021, 5.83006047147, 7234.794256242],
    [0.00000000021, 0.69628570421, 398.1490034082],
    [0.00000000022, 5.02222806555, 6127.6554505572],
    [0.0000000002, 3.4761126529, 6148.010769956],
    [0.0000000002, 0.90769829044, 5481.2549188676],
    [0.0000000002, 0.03081589303, 6418.1409300268],
    [0.0000000002, 3.74220084927, 1589.0728952838],
    [0.00000000021, 4.00149269576, 3154.6870848956],
    [0.00000000018, 1.58348238359, 2118.7638603784],
    [0.00000000019, 0.85407021371, 14712.317116458],
];

const VSOP87_B2: Vsop87Element = [
    [0.00000001662, 1.62703209173, 84334.66158130829],
    [0.00000000492, 2.41382223971, 1047.7473117547],
    [0.00000000344, 2.24353004539, 5507.5532386674],
    [0.00000000258, 6.00906896311, 5223.6939198022],
    [0.00000000131, 0.9544734524, 6283.0758499914],
    [0.00000000086, 1.67530247303, 7860.4193924392],
    [0.0000000009, 0.97606804452, 1577.3435424478],
    [0.0000000009, 0.37899871725, 2352.8661537718],
    [0.00000000089, 6.25807507963, 10213.285546211],
    [0.00000000075, 0.84213523741, 167621.57585086189],
    [0.00000000052, 1.70501566089, 14143.4952424306],
    [0.00000000057, 6.15295833679, 12194.0329146209],
    [0.00000000051, 1.2761601674, 5753.3848848968],
    [0.00000000051, 5.37229738682, 6812.766815086],
    [0.00000000034, 1.73672994279, 7058.5984613154],
    [0.00000000038, 2.77761031485, 10988.808157535],
    [0.00000000046, 3.38617099014, 156475.2902479957],
    [0.00000000021, 1.95248349228, 8827.3902698748],
    [0.00000000018, 3.33419222028, 8429.2412664666],
    [0.00000000019, 4.32945160287, 17789.845619785],
    [0.00000000017, 0.66191210656, 6283.0085396886],
    [0.00000000018, 3.74885333072, 11769.8536931664],
    [0.00000000017, 4.23058370776, 10977.078804699],
    [0.00000000017, 1.78116162721, 5486.777843175],
    [0.00000000021, 1.36972913918, 12036.4607348882],
    [0.00000000017, 2.79601092529, 796.2980068164],
    [0.00000000015, 0.4308784885, 11790.6290886588],
    [0.00000000017, 1.35132152761, 78051.5857313169],
    [0.00000000015, 1.17032155085, 213.299095438],
    [0.00000000018, 2.85221514199, 5088.6288397668],
    [0.00000000017, 0.21780913672, 6283.14316029419],
    [0.00000000013, 1.21201504386, 25132.3033999656],
    [0.00000000012, 1.12953712197, 90617.7374312997],
    [0.00000000012, 5.13714452592, 7079.3738568078],
    [0.00000000013, 3.79842135217, 4933.2084403326],
    [0.00000000012, 4.89407978213, 3738.761430108],
    [0.00000000015, 6.05682328852, 398.1490034082],
    [0.00000000014, 4.81029291856, 4694.0029547076],
    [0.00000000011, 0.61684523405, 3128.3887650958],
    [0.00000000011, 5.328765385, 6040.3472460174],
    [0.00000000014, 5.27227350286, 4535.0594369244],
    [0.00000000011, 2.39292099451, 5331.3574437408],
    [0.0000000001, 4.4529653271, 6525.8044539654],
    [0.00000000014, 4.66400985037, 8031.0922630584],
    [0.0000000001, 3.22472385926, 9437.762934887],
    [0.00000000011, 3.80913404437, 801.8209311238],
    [0.0000000001, 5.15032130575, 11371.7046897582],
    [0.00000000013, 0.98720797401, 5729.506447149],
    [0.00000000009, 5.94191743597, 7632.9432596502],
];

const VSOP87_B3: Vsop87Element = [
    [0.00000000011, 0.23877262399, 7860.4193924392],
    [0.00000000009, 1.16069982609, 5507.5532386674],
    [0.00000000008, 1.65357552925, 5884.9268465832],
    [0.00000000008, 2.86720038197, 7058.5984613154],
    [0.00000000007, 3.04818741666, 5486.777843175],
    [0.00000000007, 2.59437103785, 529.6909650946],
    [0.00000000008, 4.02863090524, 6256.7775301916],
    [0.00000000008, 2.42003508927, 5753.3848848968],
    [0.00000000006, 0.84181087594, 6275.9623029906],
    [0.00000000006, 5.40160929468, 1577.3435424478],
    [0.00000000007, 2.73399865247, 6309.3741697912],
];

const VSOP87_B4: Vsop87Element = [
    [0.00000000004, 0.79662198849, 6438.4962494256],
    [0.00000000005, 0.84308705203, 1047.7473117547],
    [0.00000000005, 0.05711572303, 84334.66158130829],
    [0.00000000003, 3.46779895686, 6279.5527316424],
    [0.00000000003, 2.89822201212, 6127.6554505572],
];

const VSOP87_B5: Vsop87Element = [[Math.LN2]];

const VSOP87_R0: Vsop87Element = [
    [1.00013988799],
    [0.01670699626, 3.09846350771, 6283.0758499914],
    [0.00013956023, 3.0552460962, 12566.1516999828],
    [0.0000308372, 5.19846674381, 77713.7714681205],
    [0.00001628461, 1.17387749012, 5753.3848848968],
    [0.00001575568, 2.84685245825, 7860.4193924392],
    [0.00000924799, 5.45292234084, 11506.7697697936],
    [0.00000542444, 4.56409149777, 3930.2096962196],
    [0.0000047211, 3.66100022149, 5884.9268465832],
    [0.0000032878, 5.89983646482, 5223.6939198022],
    [0.00000345983, 0.96368617687, 5507.5532386674],
    [0.00000306784, 0.29867139512, 5573.1428014331],
    [0.00000174844, 3.01193636534, 18849.2275499742],
    [0.00000243189, 4.27349536153, 11790.6290886588],
    [0.00000211829, 5.84714540314, 1577.3435424478],
    [0.00000185752, 5.02194447178, 10977.078804699],
    [0.00000109835, 5.05510636285, 5486.777843175],
    [0.00000098316, 0.88681311277, 6069.7767545534],
    [0.00000086499, 5.68959778254, 15720.8387848784],
    [0.00000085825, 1.27083733351, 161000.6857376741],
    [0.00000062916, 0.92177108832, 529.6909650946],
    [0.00000057056, 2.01374292014, 83996.84731811189],
    [0.00000064903, 0.27250613787, 17260.1546546904],
    [0.00000049384, 3.24501240359, 2544.3144198834],
    [0.00000055736, 5.24159798933, 71430.69561812909],
    [0.00000042515, 6.01110242003, 6275.9623029906],
    [0.00000046963, 2.57805070386, 775.522611324],
    [0.00000038968, 5.36071738169, 4694.0029547076],
    [0.00000044661, 5.53715807302, 9437.762934887],
    [0.0000003566, 1.67468058995, 12036.4607348882],
    [0.00000031921, 0.18368229781, 5088.6288397668],
    [0.00000031846, 1.77775642085, 398.1490034082],
    [0.00000033193, 0.24370300098, 7084.8967811152],
    [0.00000038245, 2.39255343974, 8827.3902698748],
    [0.00000028464, 1.21344868176, 6286.5989683404],
    [0.0000003749, 0.82952922332, 19651.048481098],
    [0.00000036957, 4.90107591914, 12139.5535091068],
    [0.00000034537, 1.84270693282, 2942.4634232916],
    [0.00000026275, 4.58896850401, 10447.3878396044],
    [0.00000024596, 3.78660875483, 8429.2412664666],
    [0.00000023587, 0.26866117066, 796.2980068164],
    [0.00000027793, 1.89934330904, 6279.5527316424],
    [0.00000023927, 4.99598548138, 5856.4776591154],
    [0.00000020349, 4.65267995431, 2146.1654164752],
    [0.00000023287, 2.80783650928, 14143.4952424306],
    [0.00000022103, 1.95004702988, 3154.6870848956],
    [0.00000019506, 5.38227371393, 2352.8661537718],
    [0.00000017958, 0.19871379385, 6812.766815086],
    [0.00000017174, 4.43315560735, 10213.285546211],
    [0.0000001619, 5.23160507859, 17789.845619785],
    [0.00000017314, 6.15200787916, 16730.4636895958],
    [0.00000013814, 5.18962074032, 8031.0922630584],
    [0.00000018833, 0.67306674027, 149854.40013480789],
    [0.00000018331, 2.25348733734, 23581.2581773176],
    [0.00000013641, 3.68516118804, 4705.7323075436],
    [0.00000013139, 0.65289581324, 13367.9726311066],
    [0.00000010414, 4.33285688538, 11769.8536931664],
    [0.00000009978, 4.20126336355, 6309.3741697912],
    [0.00000010169, 1.59390681369, 4690.4798363586],
    [0.00000007564, 2.6256059739, 6256.7775301916],
    [0.00000009661, 3.6758679122, 27511.4678735372],
    [0.00000006743, 0.56270332741, 3340.6124266998],
    [0.00000008743, 6.06359123461, 1748.016413067],
    [0.00000007786, 3.67371235637, 12168.0026965746],
    [0.00000006633, 5.66149277792, 11371.7046897582],
    [0.00000007712, 0.31242577789, 7632.9432596502],
    [0.00000006592, 3.13576266188, 801.8209311238],
    [0.0000000746, 5.64757188143, 11926.2544136688],
    [0.00000006933, 2.923845864, 6681.2248533996],
    [0.00000006802, 1.4232980642, 23013.5395395872],
    [0.00000006115, 5.13393615454, 1194.4470102246],
    [0.00000006477, 2.64986648492, 19804.8272915828],
    [0.00000005233, 4.62434053374, 6438.4962494256],
    [0.00000006147, 3.02863936662, 233141.31440436149],
    [0.00000004608, 1.72194702724, 7234.794256242],
    [0.00000004221, 1.55697533729, 7238.6755916],
    [0.00000005314, 2.40716580847, 11499.6562227928],
    [0.00000005128, 5.3239896569, 11513.8833167944],
    [0.0000000477, 0.25554312006, 11856.2186514245],
    [0.00000005519, 2.09089154502, 17298.1823273262],
    [0.00000005625, 4.34052903053, 90955.5516944961],
    [0.00000004578, 4.4656964157, 5746.271337896],
    [0.00000003788, 4.9072938351, 4164.311989613],
    [0.00000005337, 5.09957905104, 31441.6775697568],
    [0.00000003967, 1.20054555174, 1349.8674096588],
    [0.00000004008, 3.03007204392, 1059.3819301892],
    [0.00000003476, 0.7608027703, 10973.55568635],
    [0.00000004232, 1.05485713117, 5760.4984318976],
    [0.00000004582, 3.76570026763, 6386.16862421],
    [0.00000003335, 3.13829943354, 6836.6452528338],
    [0.00000003418, 3.00072390334, 4292.3308329504],
    [0.00000003598, 5.70718084323, 5643.1785636774],
    [0.00000003237, 4.16448773994, 9917.6968745098],
    [0.00000004154, 2.59941292162, 7058.5984613154],
    [0.00000003362, 4.54577697964, 4732.0306273434],
    [0.00000002978, 1.3056126882, 6283.14316029419],
    [0.00000002765, 0.51311975679, 26.2983197998],
    [0.00000002802, 5.66263240521, 8635.9420037632],
    [0.00000002927, 5.73787481548, 16200.7727245012],
    [0.00000003164, 1.69140262657, 11015.1064773348],
    [0.00000002598, 2.96244118586, 25132.3033999656],
    [0.00000003519, 3.62639325753, 244287.60000722769],
    [0.00000002676, 4.2072570085, 18073.7049386502],
    [0.00000002978, 1.74971565805, 6283.0085396886],
    [0.00000002287, 1.06975704977, 14314.1681130498],
    [0.00000002863, 5.92838131397, 14712.317116458],
    [0.00000003071, 0.23793217002, 35371.8872659764],
    [0.00000002656, 0.8995930178, 12352.8526045448],
    [0.00000002415, 2.79975176257, 709.9330485583],
    [0.00000002814, 3.51488206882, 21228.3920235458],
    [0.00000001977, 2.6135829755, 951.7184062506],
    [0.00000002548, 2.47684686575, 6208.2942514241],
    [0.00000001999, 0.5609038816, 7079.3738568078],
    [0.00000002305, 1.05376461628, 22483.84857449259],
    [0.00000001855, 2.86090681163, 5216.5803728014],
    [0.00000002157, 1.31396741861, 154717.60988768269],
    [0.0000000197, 4.36929875289, 167283.76158766549],
    [0.00000001635, 5.85571606764, 10984.1923516998],
    [0.00000001754, 2.14452408833, 6290.1893969922],
    [0.00000002154, 6.03828341543, 10873.9860304804],
    [0.00000001714, 3.70157691113, 1592.5960136328],
    [0.00000001541, 6.21598380732, 23543.23050468179],
    [0.00000001611, 1.99824499377, 10969.9652576982],
    [0.00000001712, 1.34295663542, 3128.3887650958],
    [0.00000001642, 5.55026665339, 6496.3749454294],
    [0.00000001502, 5.43948825854, 155.4203994342],
    [0.00000001827, 5.91227480261, 3738.761430108],
    [0.00000001726, 2.16764983583, 10575.4066829418],
    [0.00000001532, 5.3568310707, 13521.7514415914],
    [0.00000001829, 1.66006148731, 39302.096962196],
    [0.00000001605, 1.90928637633, 6133.5126528568],
    [0.00000001282, 2.46014880418, 13916.0191096416],
    [0.00000001211, 4.4136063155, 3894.1818295422],
    [0.00000001394, 1.77801929354, 9225.539273283],
    [0.00000001571, 4.95512957592, 25158.6017197654],
    [0.00000001205, 1.19212540615, 3.523118349],
    [0.00000001132, 2.69830084955, 6040.3472460174],
    [0.00000001504, 5.77002730341, 18209.33026366019],
    [0.00000001393, 1.62621805428, 5120.6011455836],
    [0.00000001077, 2.93931554233, 17256.6315363414],
    [0.00000001232, 0.71655165307, 143571.32428481648],
    [0.00000001087, 0.99769687939, 955.5997416086],
    [0.00000001068, 5.28472576231, 65147.6197681377],
    [0.0000000098, 5.10949204607, 6172.869528772],
    [0.00000001169, 3.11664290862, 14945.3161735544],
    [0.00000001202, 4.02992510402, 553.5694028424],
    [0.00000000979, 2.00000879212, 15110.4661198662],
    [0.00000000962, 4.023807714, 6282.0955289232],
    [0.00000000999, 3.6264300279, 6262.300454499],
    [0.0000000103, 5.84989900289, 213.299095438],
    [0.00000001014, 2.84221578218, 8662.240323563],
    [0.00000001185, 1.51330541132, 17654.7805397496],
    [0.00000000967, 2.67081017562, 5650.2921106782],
    [0.00000001222, 2.65423784904, 88860.05707098669],
    [0.00000000981, 2.36370360283, 6206.8097787158],
    [0.00000001033, 0.13874927606, 11712.9553182308],
    [0.00000001103, 3.08477302937, 43232.3066584156],
    [0.00000000781, 2.53372735932, 16496.3613962024],
    [0.00000001019, 3.04569392376, 6037.244203762],
    [0.00000000795, 5.80662989111, 5230.807466803],
    [0.00000000813, 3.57710279439, 10177.2576795336],
    [0.00000000962, 5.31470594766, 6284.0561710596],
    [0.00000000721, 5.96264301567, 12559.038152982],
    [0.00000000966, 2.74714939953, 6244.9428143536],
    [0.00000000921, 0.10155275926, 29088.811415985],
    [0.00000000692, 3.89764447548, 1589.0728952838],
    [0.00000000719, 5.91791450402, 4136.9104335162],
    [0.00000000772, 4.05505682353, 6127.6554505572],
    [0.00000000712, 5.49291532439, 22003.9146348698],
    [0.00000000672, 1.60700490811, 11087.2851259184],
    [0.0000000069, 4.50539825563, 426.598190876],
    [0.00000000854, 3.26104981596, 20426.571092422],
    [0.00000000656, 4.3241018294, 16858.4825329332],
    [0.0000000084, 2.59572585222, 28766.924424484],
    [0.00000000692, 0.61650089011, 11403.676995575],
    [0.000000007, 3.40901167143, 7.1135470008],
    [0.00000000726, 0.04243053594, 5481.2549188676],
    [0.00000000557, 4.78317696534, 20199.094959633],
    [0.00000000649, 1.04027912958, 6062.6632075526],
    [0.00000000633, 5.70229959167, 45892.73043315699],
    [0.00000000592, 6.11836729658, 9623.6882766912],
    [0.00000000523, 3.62840021266, 5333.9002410216],
    [0.00000000604, 5.57734696185, 10344.2950653858],
    [0.00000000496, 2.21023499449, 1990.745017041],
    [0.00000000691, 1.96071732602, 12416.5885028482],
    [0.0000000064, 1.59074172032, 18319.5365848796],
    [0.00000000625, 3.82362791378, 13517.8701062334],
    [0.00000000663, 5.08444996779, 283.8593188652],
    [0.00000000475, 1.17025894287, 12569.6748183318],
    [0.00000000664, 4.50029469969, 47162.5163546352],
    [0.00000000569, 0.16310365162, 17267.26820169119],
    [0.00000000568, 3.86100969474, 6076.8903015542],
    [0.00000000539, 4.83282276086, 18422.62935909819],
    [0.00000000466, 0.75872342878, 7342.4577801806],
    [0.00000000541, 3.07212190507, 226858.23855437008],
    [0.00000000458, 0.26774483096, 4590.910180489],
    [0.0000000061, 1.53597051291, 33019.0211122046],
    [0.00000000617, 2.62356328726, 11190.377900137],
    [0.00000000548, 4.55798855791, 18875.525869774],
    [0.00000000633, 4.60110281228, 66567.48586525429],
    [0.00000000596, 5.78202396722, 632.7837393132],
    [0.00000000533, 5.01786882904, 12132.439962106],
    [0.00000000603, 5.38458554802, 316428.22867391503],
    [0.00000000469, 0.59168241917, 21954.15760939799],
    [0.00000000548, 3.50613163558, 17253.04110768959],
    [0.00000000502, 0.98804327589, 11609.8625440122],
    [0.00000000568, 1.98497313089, 7668.6374249425],
    [0.00000000482, 1.62141803864, 12146.6670561076],
    [0.00000000391, 3.68718382989, 18052.9295431578],
    [0.00000000457, 3.7720573734, 156137.47598479928],
    [0.00000000401, 5.28260651958, 15671.0817594066],
    [0.00000000469, 1.80963184268, 12562.6285816338],
    [0.00000000508, 3.36399024699, 20597.2439630412],
    [0.0000000045, 5.6605429925, 10454.5013866052],
    [0.00000000375, 4.98534633105, 9779.1086761254],
    [0.00000000523, 0.97215560834, 155427.54293624099],
    [0.00000000403, 5.13939866506, 1551.045222648],
    [0.00000000372, 3.69883738807, 9388.0059094152],
    [0.00000000367, 4.43875659716, 4535.0594369244],
    [0.00000000406, 4.208631566, 12592.4500197826],
    [0.0000000036, 2.53924644657, 242.728603974],
    [0.00000000471, 4.61907324819, 5436.9930152402],
    [0.00000000441, 5.83872966262, 3496.032826134],
    [0.00000000385, 4.94496680973, 24356.7807886416],
    [0.00000000349, 6.15018231784, 19800.9459562248],
    [0.00000000355, 0.21895678106, 5429.8794682394],
    [0.00000000344, 5.62993724928, 2379.1644735716],
    [0.0000000038, 2.72105213143, 11933.3679606696],
    [0.00000000432, 0.24221790536, 17996.0311682222],
    [0.00000000378, 5.22517556974, 7477.522860216],
    [0.00000000337, 5.10888041439, 5849.3641121146],
    [0.00000000315, 0.57827745123, 10557.5941608238],
    [0.00000000318, 4.49953141399, 3634.6210245184],
    [0.00000000323, 1.54274281393, 10440.2742926036],
    [0.00000000309, 5.76839284397, 20.7753954924],
    [0.00000000301, 2.34727604008, 4686.8894077068],
    [0.00000000414, 5.9323760231, 51092.7260508548],
    [0.00000000361, 2.1639860955, 28237.2334593894],
    [0.00000000288, 0.18376252189, 13095.8426650774],
    [0.00000000277, 5.12952205045, 13119.72110282519],
    [0.00000000327, 6.19222146204, 6268.8487559898],
    [0.00000000273, 0.30522428863, 23141.5583829246],
    [0.00000000267, 5.76152585786, 5966.6839803348],
    [0.00000000308, 5.99280509979, 22805.7355659936],
    [0.00000000345, 2.92489919444, 36949.2308084242],
    [0.00000000253, 5.20995219509, 24072.9214697764],
    [0.00000000342, 5.72702586209, 16460.33352952499],
    [0.00000000261, 2.00304796059, 6148.010769956],
    [0.00000000238, 5.08264392839, 6915.8595893046],
    [0.00000000249, 2.94762789744, 135.0650800354],
    [0.00000000306, 3.89764686987, 10988.808157535],
    [0.00000000305, 0.05827812117, 4701.1165017084],
    [0.00000000319, 2.95712862064, 163096.18036118349],
    [0.00000000209, 4.43768461442, 6546.1597733642],
    [0.0000000027, 2.06643178717, 4804.209275927],
    [0.00000000217, 0.73691592312, 6303.8512454838],
    [0.00000000206, 0.32075959415, 25934.1243310894],
    [0.00000000218, 0.18428135264, 28286.9904848612],
    [0.00000000205, 5.21312087405, 20995.3929664494],
    [0.00000000199, 0.44384292491, 16737.5772365966],
    [0.0000000023, 6.06567392849, 6287.0080032545],
    [0.00000000219, 1.291942163, 5326.7866940208],
    [0.00000000201, 1.74700937253, 22743.4093795164],
    [0.00000000207, 4.45440927276, 6279.4854213396],
    [0.00000000269, 6.0564044503, 64471.99124174489],
    [0.0000000019, 0.99256176518, 29296.6153895786],
    [0.00000000238, 5.42471431221, 39609.6545831656],
    [0.00000000262, 5.26961924198, 522.5774180938],
    [0.0000000021, 4.68618183158, 6254.6266625236],
    [0.00000000197, 2.8062455408, 4933.2084403326],
    [0.00000000252, 4.36220154608, 40879.4405046438],
    [0.00000000261, 1.07241516738, 55022.9357470744],
    [0.00000000189, 3.82966734476, 419.4846438752],
    [0.00000000185, 4.14324541379, 5642.1982426092],
    [0.00000000247, 3.44855612987, 6702.5604938666],
    [0.00000000205, 4.04424043223, 536.8045120954],
    [0.00000000191, 3.14082686083, 16723.350142595],
    [0.00000000222, 5.16263907319, 23539.7073863328],
    [0.0000000018, 4.56214752149, 6489.2613984286],
    [0.00000000219, 0.80382553358, 16627.3709153772],
    [0.00000000227, 0.60156339452, 5905.7022420756],
    [0.00000000168, 0.88753528161, 16062.1845261168],
    [0.00000000158, 0.92127725775, 23937.856389741],
    [0.00000000157, 4.69607868164, 6805.6532680852],
    [0.00000000207, 4.88410451334, 6286.6662786432],
    [0.0000000016, 4.95943826846, 10021.8372800994],
    [0.00000000166, 0.97126433565, 3097.88382272579],
    [0.00000000209, 5.75663411805, 3646.3503773544],
    [0.00000000175, 6.12762824412, 239424.39025435288],
    [0.00000000173, 3.13887234973, 6179.9830757728],
    [0.00000000157, 3.62822058179, 18451.07854656599],
    [0.00000000157, 4.67695912235, 6709.6740408674],
    [0.00000000146, 3.09506069735, 4907.3020501456],
    [0.00000000165, 2.2713912876, 10660.6869350424],
    [0.00000000201, 1.67701267433, 2107.0345075424],
    [0.00000000144, 3.96947747592, 6019.9919266186],
    [0.00000000171, 5.91302216729, 6058.7310542895],
    [0.00000000144, 2.1315565512, 26084.0218062162],
    [0.00000000151, 0.67417383554, 2388.8940204492],
    [0.00000000189, 5.07122281033, 263.0839233728],
    [0.00000000146, 5.10373877968, 10770.8932562618],
    [0.00000000187, 1.23915444627, 19402.7969528166],
    [0.00000000174, 0.08407293391, 9380.9596727172],
    [0.00000000137, 1.26247412309, 12566.2190102856],
    [0.00000000137, 3.52826010842, 639.897286314],
    [0.00000000148, 1.76124372592, 5888.4499649322],
    [0.00000000164, 2.39195095081, 6357.8574485587],
    [0.00000000146, 2.43675816553, 5881.4037282342],
    [0.00000000161, 1.15721259372, 26735.9452622132],
    [0.00000000131, 2.51859277344, 6599.467719648],
    [0.00000000153, 5.85203687779, 6281.5913772831],
    [0.00000000151, 3.72338532649, 12669.2444742014],
    [0.00000000132, 2.38417741883, 6525.8044539654],
    [0.00000000129, 0.75556744143, 5017.508371365],
    [0.00000000127, 0.00254936441, 10027.9031957292],
    [0.00000000148, 2.85102145528, 6418.1409300268],
    [0.00000000143, 5.74460279367, 26087.9031415742],
    [0.00000000172, 0.4128996224, 174242.4659640497],
    [0.00000000136, 4.15497742275, 6311.5250374592],
    [0.0000000017, 5.98194913129, 327574.51427678125],
    [0.00000000124, 1.65497607604, 32217.2001810808],
    [0.00000000136, 2.48430783417, 13341.6743113068],
    [0.00000000165, 2.496679246, 58953.145443294],
    [0.00000000123, 3.45660563754, 6277.552925684],
    [0.00000000117, 0.86065134175, 6245.0481773556],
    [0.00000000149, 5.61358280963, 5729.506447149],
    [0.00000000153, 0.2686002995, 245.8316462294],
    [0.00000000128, 0.71204006588, 103.0927742186],
    [0.00000000159, 2.43166592149, 221995.02880149524],
    [0.0000000013, 2.80707316718, 6016.4688082696],
    [0.00000000137, 1.70657709294, 12566.08438968],
    [0.00000000111, 1.56305648432, 17782.7320727842],
    [0.00000000113, 3.58302904101, 25685.872802808],
    [0.00000000109, 3.26403795962, 6819.8803620868],
    [0.00000000122, 0.34120688217, 1162.4747044078],
    [0.00000000119, 5.84644718278, 12721.572099417],
    [0.00000000144, 2.28899679126, 12489.8856287072],
    [0.00000000137, 5.82029768354, 44809.6502008634],
    [0.00000000107, 2.4281854414, 5547.1993364596],
    [0.00000000134, 1.26539982939, 5331.3574437408],
    [0.00000000103, 5.96518130595, 6321.1035226272],
    [0.00000000109, 0.33808549034, 11300.5842213564],
    [0.00000000129, 5.89187277327, 12029.3471878874],
    [0.00000000122, 5.77325634636, 11919.140866668],
    [0.00000000107, 6.2499898935, 77690.75950573849],
    [0.00000000107, 1.00535580713, 77736.78343050249],
    [0.00000000143, 0.24122178432, 4214.0690150848],
    [0.00000000143, 0.88529649733, 7576.560073574],
    [0.00000000107, 2.92124030496, 31415.379249957],
    [0.00000000099, 5.70862227072, 5540.0857894588],
    [0.0000000011, 0.37528037383, 5863.5912061162],
    [0.00000000104, 4.44107178366, 2118.7638603784],
    [0.00000000098, 5.95877916706, 4061.2192153944],
    [0.00000000113, 1.24206857385, 84672.47584450469],
    [0.00000000124, 2.55619029867, 12539.853380183],
    [0.0000000011, 3.66952094329, 238004.52415723629],
    [0.00000000112, 4.32512422943, 97238.62754448749],
    [0.00000000097, 3.70151541181, 11720.0688652316],
    [0.0000000012, 1.26895630252, 12043.574281889],
    [0.00000000094, 2.56461130309, 19004.6479494084],
    [0.00000000117, 3.65425622684, 34520.3093093808],
    [0.00000000098, 0.13589994287, 11080.1715789176],
    [0.00000000097, 5.38330115253, 7834.1210726394],
    [0.00000000097, 2.46722096722, 71980.63357473118],
    [0.00000000095, 5.36958330451, 6288.5987742988],
    [0.00000000111, 5.01961920313, 11823.1616394502],
    [0.0000000009, 2.72299804525, 26880.3198130326],
    [0.00000000099, 0.90164266377, 18635.9284545362],
    [0.00000000126, 4.78722177847, 305281.94307104882],
    [0.00000000093, 0.21240380046, 18139.2945014159],
    [0.00000000124, 5.00979495566, 172146.97134054029],
    [0.00000000099, 5.67090026475, 16522.6597160022],
    [0.00000000092, 2.28180963676, 12491.3701014155],
    [0.0000000009, 4.50544881196, 40077.61957352],
    [0.000000001, 2.00639461612, 12323.4230960088],
    [0.00000000095, 5.68801979087, 14919.0178537546],
    [0.00000000087, 1.86043406047, 27707.5424942948],
    [0.00000000105, 3.02903468417, 22345.2603761082],
    [0.00000000087, 5.43970168638, 6272.0301497275],
    [0.00000000089, 1.63389387182, 33326.5787331742],
    [0.00000000082, 5.58298993353, 10241.2022911672],
    [0.00000000094, 5.47749711149, 9924.8104215106],
    [0.00000000082, 4.71988314145, 15141.390794312],
    [0.00000000097, 5.61458778738, 2787.0430238574],
    [0.00000000096, 3.89073946348, 6379.0550772092],
    [0.00000000081, 3.13038482444, 36147.4098773004],
    [0.0000000011, 4.89978492291, 72140.62866668739],
    [0.00000000097, 5.20764563059, 6303.4311693902],
    [0.00000000082, 5.26342716139, 9814.6041002912],
    [0.00000000109, 2.3555558977, 83286.91426955358],
    [0.00000000097, 2.58492958057, 30666.1549584328],
    [0.00000000093, 1.32651591333, 23020.65308658799],
    [0.00000000078, 3.99588630754, 11293.4706743556],
    [0.0000000009, 0.57771932738, 26482.1708096244],
    [0.00000000106, 3.92012705073, 62883.3551395136],
    [0.00000000098, 2.94397773524, 316.3918696566],
    [0.00000000076, 3.96310417608, 29026.48522950779],
    [0.00000000078, 1.97068529306, 90279.92316810328],
    [0.00000000076, 0.23027966596, 21424.4666443034],
    [0.0000000008, 2.23099742212, 266.6070417218],
    [0.00000000079, 1.46227790922, 8982.810669309],
    [0.00000000102, 4.92129953565, 5621.8429232104],
    [0.000000001, 0.39243148321, 24279.10701821359],
    [0.00000000071, 1.52014858474, 33794.5437235286],
    [0.00000000076, 0.22880641443, 57375.8019008462],
    [0.00000000091, 0.96515913904, 48739.859897083],
    [0.00000000075, 2.77638585157, 12964.300703391],
    [0.00000000077, 5.18846946344, 11520.9968637952],
    [0.00000000068, 0.50006599129, 4274.5183108324],
    [0.00000000075, 2.07323762803, 15664.03552270859],
    [0.00000000074, 1.01884134928, 6393.2821712108],
    [0.00000000077, 0.4666517878, 16207.886271502],
    [0.00000000081, 4.10452219483, 161710.61878623239],
    [0.00000000067, 3.83840630887, 6262.7205305926],
    [0.00000000071, 3.91415523291, 7875.6718636242],
    [0.00000000081, 0.91938383237, 74.7815985673],
    [0.00000000083, 4.69916218791, 23006.42599258639],
    [0.00000000063, 2.32556465878, 6279.1945146334],
    [0.00000000065, 5.41938745446, 28628.3362260996],
    [0.00000000065, 3.02336771694, 5959.570433334],
    [0.00000000064, 3.3103319837, 2636.725472637],
    [0.00000000064, 0.18375587519, 1066.49547719],
    [0.0000000008, 5.81239171612, 12341.8069042809],
    [0.00000000066, 2.15105504851, 38.0276726358],
    [0.00000000062, 2.43313614978, 10138.1095169486],
    [0.0000000006, 3.1615390647, 5490.300961524],
    [0.00000000069, 0.30764736334, 7018.9523635232],
    [0.00000000068, 2.24442548639, 24383.0791084414],
    [0.00000000078, 1.39649386463, 9411.4646150872],
    [0.00000000063, 0.72976362625, 6286.9571853494],
    [0.00000000073, 4.95125917731, 6453.7487206106],
    [0.00000000078, 0.32736023459, 6528.9074962208],
    [0.00000000059, 4.95362151577, 35707.7100829074],
    [0.0000000007, 2.37962727525, 15508.6151232744],
    [0.00000000073, 1.35229143111, 5327.4761083828],
    [0.00000000072, 5.91833527334, 10881.0995774812],
    [0.00000000059, 5.36231868425, 10239.5838660108],
    [0.00000000059, 1.63156134967, 61306.0115970658],
    [0.00000000054, 4.29491690425, 21947.1113727],
    [0.00000000057, 5.89190132575, 34513.2630726828],
    [0.00000000074, 1.38235845304, 9967.4538999816],
    [0.00000000053, 3.86543309344, 32370.9789915656],
    [0.00000000055, 4.51794544854, 34911.412076091],
    [0.00000000063, 5.41479412056, 11502.8376165305],
    [0.00000000063, 2.34416220742, 11510.7019230567],
    [0.00000000068, 0.77493931112, 29864.334027309],
    [0.0000000006, 5.57024703495, 5756.9080032458],
    [0.00000000072, 2.80863088166, 10866.8724834796],
    [0.00000000061, 2.69736991384, 82576.98122099529],
    [0.00000000063, 5.32068807257, 3116.6594122598],
    [0.00000000052, 1.02278758099, 6272.4391846416],
    [0.00000000069, 5.00698550308, 25287.7237993998],
    [0.00000000066, 6.12047940728, 12074.488407524],
    [0.00000000051, 2.59519527563, 11396.5634485742],
    [0.00000000056, 2.57995973521, 17892.93839400359],
    [0.00000000059, 0.4416723762, 250570.67585721909],
    [0.00000000059, 3.84070143543, 5483.254724826],
    [0.00000000049, 0.54704693048, 22594.05489571199],
    [0.00000000065, 2.38423614501, 52670.0695933026],
    [0.00000000069, 5.34363738671, 66813.5648357332],
    [0.00000000057, 5.42770501007, 310145.15282392364],
    [0.00000000053, 1.17760296075, 149.5631971346],
    [0.00000000061, 4.02090887211, 34596.3646546524],
    [0.00000000049, 4.18361320516, 18606.4989460002],
    [0.00000000055, 0.83886167974, 20452.8694122218],
    [0.0000000005, 1.46327331958, 37455.7264959744],
    [0.00000000048, 4.53854727167, 29822.7832363242],
    [0.00000000058, 3.34847975377, 33990.6183442862],
    [0.00000000065, 1.45522693982, 76251.32777062019],
    [0.00000000056, 2.35650663692, 37724.7534197482],
    [0.00000000052, 2.61551081496, 5999.2165311262],
    [0.00000000053, 0.17334326094, 77717.29458646949],
    [0.00000000053, 0.79879700631, 77710.24834977149],
    [0.00000000047, 0.43240779709, 735.8765135318],
    [0.00000000053, 4.58763261686, 11616.976091013],
    [0.00000000048, 6.20230111054, 4171.4255366138],
    [0.00000000052, 1.09723616404, 640.8776073822],
    [0.00000000057, 3.42008310383, 50317.2034395308],
    [0.00000000053, 1.01528448581, 149144.46708624958],
    [0.00000000047, 3.00924906195, 52175.8062831484],
    [0.00000000052, 2.03254070404, 6293.7125153412],
    [0.00000000048, 0.12356889734, 13362.4497067992],
    [0.00000000045, 3.37963782356, 10763.779709261],
    [0.00000000047, 5.50981287869, 12779.4507954208],
    [0.00000000062, 5.45209070099, 949.1756089698],
    [0.00000000061, 2.93237974631, 5791.4125575326],
    [0.00000000044, 2.87440620802, 8584.6616659008],
    [0.00000000046, 4.0314179656, 10667.8004820432],
    [0.00000000047, 3.89902931422, 3903.9113764198],
    [0.00000000046, 2.75700467329, 6993.0088985497],
    [0.00000000045, 1.933862933, 206.1855484372],
    [0.00000000047, 2.57670800912, 11492.542675792],
    [0.00000000044, 3.62570223167, 63658.8777508376],
    [0.00000000051, 0.84536826273, 12345.739057544],
    [0.00000000043, 0.01524970172, 37853.8754993826],
    [0.00000000041, 3.27146326065, 8858.3149443206],
    [0.00000000045, 3.03765521215, 65236.2212932854],
    [0.00000000047, 1.44447548944, 21393.5419698576],
    [0.00000000058, 5.45843180927, 1975.492545856],
    [0.0000000005, 2.13285524146, 12573.2652469836],
    [0.00000000041, 1.32190847146, 2547.8375382324],
    [0.00000000047, 3.67579608544, 28313.288804661],
    [0.00000000041, 2.24013475126, 8273.8208670324],
    [0.00000000047, 6.21438985953, 10991.3058987006],
    [0.00000000042, 3.0163181735, 853.196381752],
    [0.00000000056, 1.09773690181, 77376.20102240759],
    [0.0000000004, 2.35698541041, 2699.7348193176],
    [0.00000000043, 5.28030898459, 17796.9591667858],
    [0.00000000054, 2.59175932091, 22910.44676536859],
    [0.00000000054, 0.88027764102, 71960.38658322369],
    [0.00000000055, 0.07988899477, 83467.15635301729],
    [0.00000000039, 1.12867321442, 9910.583327509],
    [0.0000000004, 1.35670430524, 27177.8515292002],
    [0.00000000039, 4.39624220245, 5618.3198048614],
    [0.00000000042, 4.78798367468, 7856.89627409019],
    [0.00000000047, 2.75482175292, 18202.21671665939],
    [0.00000000039, 1.97008298629, 24491.4257925834],
    [0.00000000042, 4.04346599946, 7863.9425107882],
    [0.00000000038, 0.49178679251, 38650.173506199],
    [0.00000000036, 4.86047906533, 4157.1984426122],
    [0.00000000043, 5.64354880978, 1062.9050485382],
    [0.00000000036, 3.98066313627, 12565.1713789146],
    [0.00000000042, 2.30753932657, 6549.6828917132],
    [0.0000000004, 5.3969491832, 9498.2122306346],
    [0.0000000004, 3.30603243754, 23536.11695768099],
    [0.0000000005, 6.15760345261, 78051.34191383338],
];

const VSOP87_R1: Vsop87Element = [
    [0.00103018608, 1.10748969588, 6283.0758499914],
    [0.00001721238, 1.06442301418, 12566.1516999828],
    [0.00000702215, Math.PI],
    [0.00000032346, 1.02169059149, 18849.2275499742],
    [0.00000030799, 2.84353804832, 5507.5532386674],
    [0.00000024971, 1.31906709482, 5223.6939198022],
    [0.00000018485, 1.42429748614, 1577.3435424478],
    [0.00000010078, 5.91378194648, 10977.078804699],
    [0.00000008634, 0.27146150602, 5486.777843175],
    [0.00000008654, 1.42046854427, 6275.9623029906],
    [0.00000005069, 1.68613426734, 5088.6288397668],
    [0.00000004985, 6.01401770704, 6286.5989683404],
    [0.00000004669, 5.98724494073, 529.6909650946],
    [0.00000004395, 0.51800238019, 4694.0029547076],
    [0.00000003872, 4.74969833437, 2544.3144198834],
    [0.0000000375, 5.07097685568, 796.2980068164],
    [0.000000041, 1.08424786092, 9437.762934887],
    [0.00000003518, 0.02290216272, 83996.84731811189],
    [0.00000003436, 0.94937019624, 71430.69561812909],
    [0.00000003221, 6.15628775313, 2146.1654164752],
    [0.00000003414, 5.41218322538, 775.522611324],
    [0.00000002863, 5.48432847146, 10447.3878396044],
    [0.0000000252, 0.24276941146, 398.1490034082],
    [0.00000002201, 4.95216196651, 6812.766815086],
    [0.00000002186, 0.41991743105, 8031.0922630584],
    [0.00000002838, 3.42034351366, 2352.8661537718],
    [0.00000002554, 6.13241878525, 6438.4962494256],
    [0.00000001932, 5.31374608366, 8429.2412664666],
    [0.00000002429, 3.09164528262, 4690.4798363586],
    [0.0000000173, 1.5368620855, 4705.7323075436],
    [0.0000000225, 3.68863633842, 7084.8967811152],
    [0.00000002093, 1.28191783032, 1748.016413067],
    [0.00000001441, 0.81656250862, 14143.4952424306],
    [0.00000001483, 3.22225357771, 7234.794256242],
    [0.00000001754, 3.22883705112, 6279.5527316424],
    [0.00000001583, 4.09702349428, 11499.6562227928],
    [0.00000001575, 5.53890170575, 3154.6870848956],
    [0.00000001847, 1.82040335363, 7632.9432596502],
    [0.00000001504, 3.63293385726, 11513.8833167944],
    [0.00000001337, 4.64440864339, 6836.6452528338],
    [0.00000001275, 2.69341415363, 1349.8674096588],
    [0.00000001352, 6.15101580257, 5746.271337896],
    [0.00000001125, 3.35673439497, 17789.845619785],
    [0.0000000147, 3.65282991755, 1194.4470102246],
    [0.00000001177, 2.57676109092, 13367.9726311066],
    [0.00000001101, 4.49748696552, 4292.3308329504],
    [0.00000001234, 5.65036509521, 5760.4984318976],
    [0.00000000984, 0.65517395136, 5856.4776591154],
    [0.00000000928, 2.32420318751, 10213.285546211],
    [0.00000001077, 5.82812169132, 12036.4607348882],
    [0.00000000916, 0.76613009583, 16730.4636895958],
    [0.00000000877, 1.50137505051, 11926.2544136688],
    [0.00000001023, 5.62076589825, 6256.7775301916],
    [0.00000000851, 0.65709335533, 155.4203994342],
    [0.00000000802, 4.10519132088, 951.7184062506],
    [0.00000000857, 1.41661697538, 5753.3848848968],
    [0.00000000994, 1.14418521187, 1059.3819301892],
    [0.00000000813, 1.63948433322, 6681.2248533996],
    [0.00000000662, 4.5520045226, 5216.5803728014],
    [0.00000000644, 4.19478168733, 6040.3472460174],
    [0.00000000626, 1.50767713598, 5643.1785636774],
    [0.0000000059, 6.18277145205, 4164.311989613],
    [0.00000000635, 0.52413263542, 6290.1893969922],
    [0.0000000065, 0.9793569035, 25132.3033999656],
    [0.00000000568, 2.30125315873, 10973.55568635],
    [0.00000000547, 5.27256412213, 3340.6124266998],
    [0.00000000547, 2.20144422886, 1592.5960136328],
    [0.00000000526, 0.92464258226, 11371.7046897582],
    [0.0000000049, 5.90951388655, 3894.1818295422],
    [0.00000000478, 1.66857963179, 12168.0026965746],
    [0.00000000516, 3.59803483887, 10969.9652576982],
    [0.00000000518, 3.97914412373, 17298.1823273262],
    [0.00000000534, 5.03740926442, 9917.6968745098],
    [0.00000000487, 2.50545369269, 6127.6554505572],
    [0.00000000416, 4.04828175503, 10984.1923516998],
    [0.00000000538, 5.54081539805, 553.5694028424],
    [0.00000000402, 2.16544019233, 7860.4193924392],
    [0.00000000553, 2.32177369366, 11506.7697697936],
    [0.00000000367, 3.3915253225, 6496.3749454294],
    [0.0000000036, 5.34379853282, 7079.3738568078],
    [0.00000000337, 3.61563704045, 11790.6290886588],
    [0.00000000456, 0.30754294809, 801.8209311238],
    [0.00000000417, 3.70009308674, 10575.4066829418],
    [0.00000000381, 5.82033971802, 7058.5984613154],
    [0.00000000321, 0.31988767355, 16200.7727245012],
    [0.00000000364, 1.08414306177, 6309.3741697912],
    [0.00000000294, 4.54798604957, 11856.2186514245],
    [0.0000000029, 1.26473978562, 8635.9420037632],
    [0.00000000399, 4.16998866302, 26.2983197998],
    [0.00000000262, 5.08316906342, 10177.2576795336],
    [0.00000000243, 2.2574609119, 11712.9553182308],
    [0.00000000237, 1.05070575346, 242.728603974],
    [0.00000000275, 3.45319481756, 5884.9268465832],
    [0.00000000255, 5.38496831087, 21228.3920235458],
    [0.00000000307, 4.24313526604, 3738.761430108],
    [0.00000000216, 3.46037894728, 213.299095438],
    [0.00000000196, 0.69029243914, 1990.745017041],
    [0.00000000198, 5.16301829964, 12352.8526045448],
    [0.00000000214, 3.91876200279, 13916.0191096416],
    [0.00000000212, 4.00861198517, 5230.807466803],
    [0.00000000184, 5.59805976614, 6283.14316029419],
    [0.00000000184, 2.85275392124, 7238.6755916],
    [0.00000000179, 2.54259058334, 14314.1681130498],
    [0.00000000225, 1.64458698399, 4732.0306273434],
    [0.00000000236, 5.58826125715, 6069.7767545534],
    [0.00000000187, 2.72805985443, 6062.6632075526],
    [0.00000000184, 6.04216273598, 6283.0085396886],
    [0.0000000023, 3.62591335086, 6284.0561710596],
    [0.00000000163, 2.19117396803, 18073.7049386502],
    [0.00000000172, 0.9761295074, 3930.2096962196],
    [0.00000000215, 1.04672844028, 3496.032826134],
    [0.00000000169, 4.75084479006, 17267.26820169119],
    [0.00000000152, 0.19390712179, 9779.1086761254],
    [0.00000000182, 5.16288118255, 17253.04110768959],
    [0.00000000149, 0.8094418426, 709.9330485583],
    [0.00000000163, 2.1920957039, 6076.8903015542],
    [0.00000000186, 5.01159497089, 11015.1064773348],
    [0.00000000134, 0.97765485759, 65147.6197681377],
    [0.00000000141, 4.38421981312, 4136.9104335162],
    [0.00000000158, 4.60974280627, 9623.6882766912],
    [0.00000000133, 3.30508592837, 154717.60988768269],
    [0.00000000163, 6.11782626245, 3.523118349],
    [0.00000000174, 1.58078542187, 7.1135470008],
    [0.00000000141, 0.49976927274, 25158.6017197654],
    [0.00000000124, 6.03440460031, 9225.539273283],
    [0.0000000015, 5.30166336812, 13517.8701062334],
    [0.00000000127, 1.92389511438, 22483.84857449259],
    [0.00000000121, 2.37813129011, 167283.76158766549],
    [0.0000000012, 3.98423684853, 4686.8894077068],
    [0.00000000117, 5.81072642211, 12569.6748183318],
    [0.00000000122, 5.60973054224, 5642.1982426092],
    [0.00000000157, 3.40236426002, 16496.3613962024],
    [0.00000000129, 2.10705116371, 1589.0728952838],
    [0.00000000116, 0.55839966736, 5849.3641121146],
    [0.00000000123, 1.52961392771, 12559.038152982],
    [0.00000000111, 0.44848279675, 6172.869528772],
    [0.00000000123, 5.81645568991, 6282.0955289232],
    [0.0000000015, 4.26278409223, 3128.3887650958],
    [0.00000000106, 2.27437761356, 5429.8794682394],
    [0.00000000104, 4.42743707728, 23543.23050468179],
    [0.00000000121, 0.39459045915, 12132.439962106],
    [0.00000000104, 2.41842602527, 426.598190876],
    [0.0000000011, 5.80381480447, 16858.4825329332],
    [0.000000001, 2.93805577485, 4535.0594369244],
    [0.00000000097, 3.97935904984, 6133.5126528568],
    [0.0000000011, 6.22339014386, 12146.6670561076],
    [0.00000000098, 0.87576563709, 6525.8044539654],
    [0.00000000098, 3.15248421301, 10440.2742926036],
    [0.00000000095, 2.461684111, 3097.88382272579],
    [0.00000000088, 0.23371480284, 13119.72110282519],
    [0.00000000098, 5.77016493489, 7342.4577801806],
    [0.00000000092, 6.03915555063, 20426.571092422],
    [0.00000000096, 5.56909292561, 2388.8940204492],
    [0.00000000081, 1.32131147691, 5650.2921106782],
    [0.00000000086, 3.94529200528, 10454.5013866052],
    [0.00000000076, 2.70729716925, 143571.32428481648],
    [0.00000000091, 5.64100034152, 8827.3902698748],
    [0.00000000076, 1.80783856698, 28286.9904848612],
    [0.00000000081, 1.90858992196, 29088.811415985],
    [0.00000000075, 3.40955892978, 5481.2549188676],
    [0.00000000069, 4.49936170873, 17256.6315363414],
    [0.00000000088, 1.10098454357, 11769.8536931664],
    [0.00000000066, 2.78285801977, 536.8045120954],
    [0.00000000068, 3.88179770758, 17260.1546546904],
    [0.00000000084, 1.59303306354, 9380.9596727172],
    [0.00000000088, 3.88076636762, 7477.522860216],
    [0.00000000061, 6.17558202197, 11087.2851259184],
    [0.0000000006, 4.34824715818, 6206.8097787158],
    [0.00000000082, 4.59843208943, 9388.0059094152],
    [0.00000000079, 1.63131230601, 4933.2084403326],
    [0.00000000078, 4.20905757484, 5729.506447149],
    [0.00000000057, 5.48157926651, 18319.5365848796],
    [0.0000000006, 1.01261781084, 12721.572099417],
    [0.00000000056, 1.63031935692, 15720.8387848784],
    [0.00000000055, 0.24926735018, 15110.4661198662],
    [0.00000000061, 5.93059279661, 12539.853380183],
    [0.00000000055, 4.84298966314, 13095.8426650774],
    [0.00000000067, 6.11690589247, 8662.240323563],
    [0.00000000054, 5.73750638571, 3634.6210245184],
    [0.00000000074, 1.05466745829, 16460.33352952499],
    [0.00000000053, 2.29084335688, 16062.1845261168],
    [0.00000000064, 2.13513767927, 7875.6718636242],
    [0.00000000067, 0.07096807518, 14945.3161735544],
    [0.00000000051, 2.31511194429, 6262.7205305926],
    [0.00000000057, 5.77055471237, 12043.574281889],
    [0.00000000056, 4.41980790431, 4701.1165017084],
    [0.00000000059, 5.87963500073, 5331.3574437408],
    [0.00000000058, 2.30546168628, 955.5997416086],
    [0.00000000049, 1.93839278478, 5333.9002410216],
    [0.00000000048, 2.69973662261, 6709.6740408674],
    [0.00000000064, 1.64379897981, 6262.300454499],
    [0.00000000046, 3.98449608961, 98068.53671630539],
    [0.0000000005, 3.68875893005, 12323.4230960088],
    [0.00000000045, 3.30068569697, 22003.9146348698],
    [0.00000000047, 1.26317154881, 11919.140866668],
    [0.00000000045, 0.89150445122, 51868.2486621788],
    [0.00000000043, 1.61526242998, 6277.552925684],
    [0.00000000043, 5.74295325645, 11403.676995575],
    [0.00000000044, 3.43070646822, 10021.8372800994],
    [0.00000000056, 0.02481833774, 15671.0817594066],
    [0.00000000055, 3.14274403422, 33019.0211122046],
    [0.00000000045, 3.00877289177, 8982.810669309],
    [0.00000000046, 0.73303568429, 6303.4311693902],
    [0.00000000049, 1.60455690285, 6303.8512454838],
    [0.00000000045, 0.40210030323, 6805.6532680852],
    [0.00000000053, 0.94869680175, 10988.808157535],
    [0.00000000041, 1.61122384329, 6819.8803620868],
    [0.00000000055, 0.89439119424, 11933.3679606696],
    [0.00000000045, 3.88495384656, 60530.4889857418],
    [0.0000000004, 4.75740908001, 38526.574350872],
    [0.0000000004, 1.49921251887, 18451.07854656599],
    [0.0000000004, 3.77498297228, 26087.9031415742],
    [0.00000000051, 1.70258603562, 1551.045222648],
    [0.00000000039, 2.97100699926, 2118.7638603784],
    [0.00000000053, 5.19854123078, 77713.7714681205],
    [0.00000000047, 4.26356628717, 21424.4666443034],
    [0.00000000037, 0.62902722802, 24356.7807886416],
    [0.00000000036, 0.11087914947, 10344.2950653858],
    [0.00000000036, 0.77037556319, 12029.3471878874],
    [0.00000000035, 3.30933994515, 24072.9214697764],
    [0.00000000035, 5.93650887012, 31570.7996493912],
    [0.00000000036, 2.15108874765, 30774.5016425748],
    [0.00000000036, 1.75078825382, 16207.886271502],
    [0.00000000033, 5.06264177921, 226858.23855437008],
    [0.00000000034, 6.168913788, 24491.4257925834],
    [0.00000000035, 3.19120695549, 32217.2001810808],
    [0.00000000034, 2.31528650443, 55798.4583583984],
    [0.00000000032, 4.21446357042, 15664.03552270859],
    [0.00000000039, 1.24979117796, 6418.1409300268],
    [0.00000000037, 4.1194365577, 2787.0430238574],
    [0.00000000032, 1.6288771089, 639.897286314],
    [0.00000000038, 5.89832942685, 640.8776073822],
    [0.00000000032, 1.72442327688, 27433.88921587499],
    [0.00000000031, 2.78828943753, 12139.5535091068],
    [0.00000000035, 4.44608896525, 18202.21671665939],
    [0.00000000034, 3.96287980676, 18216.443810661],
    [0.00000000033, 4.73611335874, 16723.350142595],
    [0.00000000034, 1.43910280005, 49515.382508407],
    [0.00000000031, 0.23302920161, 23581.2581773176],
    [0.00000000029, 2.0263384022, 11609.8625440122],
    [0.0000000003, 2.5492323024, 9924.8104215106],
    [0.00000000032, 4.91793198558, 11300.5842213564],
    [0.00000000028, 0.26187189577, 13521.7514415914],
    [0.00000000028, 3.84568936822, 2699.7348193176],
    [0.00000000029, 1.83149729794, 29822.7832363242],
    [0.00000000033, 4.60320094415, 19004.6479494084],
    [0.00000000027, 4.46183450287, 6702.5604938666],
    [0.0000000003, 4.4649407224, 36147.4098773004],
    [0.00000000027, 0.03211931363, 6279.7894925736],
    [0.00000000026, 5.46497324333, 6245.0481773556],
    [0.00000000035, 4.52695674113, 36949.2308084242],
    [0.00000000027, 3.52528177609, 10770.8932562618],
    [0.00000000026, 1.48499438453, 11080.1715789176],
    [0.00000000035, 2.82154380962, 19402.7969528166],
    [0.00000000025, 2.46339998836, 6279.4854213396],
    [0.00000000026, 4.97688894643, 16737.5772365966],
    [0.00000000026, 2.36136541526, 17996.0311682222],
    [0.00000000029, 4.15148654061, 45892.73043315699],
    [0.00000000026, 4.50714272714, 17796.9591667858],
    [0.00000000027, 4.72625223674, 1066.49547719],
    [0.00000000025, 2.89309528854, 6286.6662786432],
    [0.00000000027, 0.37462444357, 12964.300703391],
    [0.00000000029, 4.94860010533, 5863.5912061162],
    [0.00000000031, 3.93096113577, 29864.334027309],
    [0.00000000024, 6.14987193584, 18606.4989460002],
    [0.00000000024, 3.74225964547, 29026.48522950779],
    [0.00000000025, 5.70460621565, 27707.5424942948],
    [0.00000000025, 5.33928840652, 15141.390794312],
    [0.00000000027, 3.0232089714, 6286.3622074092],
    [0.00000000023, 0.28364955406, 5327.4761083828],
    [0.00000000026, 1.34240461687, 18875.525869774],
    [0.00000000024, 1.33998410121, 19800.9459562248],
    [0.00000000025, 6.00172494004, 6489.2613984286],
    [0.00000000022, 1.81777974484, 6288.5987742988],
    [0.00000000022, 3.5860360664, 6915.8595893046],
    [0.00000000029, 2.09564449439, 15265.8865193004],
    [0.00000000022, 1.02173599251, 11925.2740926006],
    [0.00000000022, 4.74660932338, 28230.18722269139],
    [0.00000000021, 2.30688751432, 5999.2165311262],
    [0.00000000021, 3.2265494443, 25934.1243310894],
    [0.00000000021, 3.04956726238, 6566.9351688566],
    [0.00000000027, 5.35653084499, 33794.5437235286],
    [0.00000000028, 3.91168324815, 18208.349942592],
    [0.0000000002, 1.52296293311, 135.0650800354],
    [0.00000000022, 4.66462839521, 13362.4497067992],
    [0.00000000019, 1.78121167862, 156137.47598479928],
    [0.00000000019, 2.99969102221, 19651.048481098],
    [0.00000000019, 2.86664273362, 18422.62935909819],
    [0.00000000025, 0.94995632141, 31415.379249957],
    [0.00000000019, 4.71432851499, 77690.75950573849],
    [0.00000000019, 2.54227398241, 77736.78343050249],
    [0.0000000002, 5.91915117116, 48739.859897083],
];

const VSOP87_R2: Vsop87Element = [
    [0.00004359385, 5.78455133738, 6283.0758499914],
    [0.00000123633, 5.57934722157, 12566.1516999828],
    [0.00000012341, Math.PI],
    [0.00000008792, 3.62777733395, 77713.7714681205],
    [0.00000005689, 1.86958905084, 5573.1428014331],
    [0.00000003301, 5.47027913302, 18849.2275499742],
    [0.00000001471, 4.48028885617, 5507.5532386674],
    [0.00000001013, 2.81456417694, 5223.6939198022],
    [0.00000000854, 3.10878241236, 1577.3435424478],
    [0.00000001102, 2.84173992403, 161000.6857376741],
    [0.00000000648, 5.47349498544, 775.522611324],
    [0.00000000609, 1.37969434104, 6438.4962494256],
    [0.00000000499, 4.4164924225, 6286.5989683404],
    [0.00000000417, 0.90242451175, 10977.078804699],
    [0.00000000402, 3.2037658529, 5088.6288397668],
    [0.00000000351, 1.8107922777, 5486.777843175],
    [0.00000000467, 3.65753702738, 7084.8967811152],
    [0.00000000458, 5.38585314743, 149854.40013480789],
    [0.00000000304, 3.51701098693, 796.2980068164],
    [0.00000000266, 6.17413982699, 6836.6452528338],
    [0.00000000279, 1.84120501086, 4694.0029547076],
    [0.0000000026, 1.41629543251, 2146.1654164752],
    [0.00000000266, 3.13832905677, 71430.69561812909],
    [0.00000000321, 5.35313367048, 3154.6870848956],
    [0.00000000238, 2.17720020018, 155.4203994342],
    [0.00000000293, 4.61501268144, 4690.4798363586],
    [0.00000000229, 4.7596958807, 7234.794256242],
    [0.00000000211, 0.21868065485, 4705.7323075436],
    [0.00000000201, 4.21905743357, 1349.8674096588],
    [0.00000000195, 4.57808285364, 529.6909650946],
    [0.00000000253, 2.81496293039, 1748.016413067],
    [0.00000000182, 5.70454011389, 6040.3472460174],
    [0.00000000179, 6.02897097053, 4292.3308329504],
    [0.00000000186, 1.58690991244, 6309.3741697912],
    [0.0000000017, 2.90220009715, 9437.762934887],
    [0.00000000166, 1.99984925026, 8031.0922630584],
    [0.00000000158, 0.04783713552, 2544.3144198834],
    [0.00000000197, 2.01083639502, 1194.4470102246],
    [0.00000000165, 5.78372596778, 83996.84731811189],
    [0.00000000214, 3.38285934319, 7632.9432596502],
    [0.0000000014, 0.36401486094, 10447.3878396044],
    [0.00000000151, 0.95153163031, 6127.6554505572],
    [0.00000000136, 1.48426306582, 2352.8661537718],
    [0.00000000127, 5.48475435134, 951.7184062506],
    [0.00000000126, 5.26866506592, 6279.5527316424],
    [0.00000000125, 3.75754889288, 6812.766815086],
    [0.00000000101, 4.95015746147, 398.1490034082],
    [0.00000000102, 0.68468295277, 1592.5960136328],
    [0.000000001, 1.14568935785, 3894.1818295422],
    [0.00000000129, 0.76540016965, 553.5694028424],
    [0.00000000109, 5.41063597567, 6256.7775301916],
    [0.00000000075, 5.84804322893, 242.728603974],
    [0.00000000095, 1.94452244083, 11856.2186514245],
    [0.00000000077, 0.69373708195, 8429.2412664666],
    [0.000000001, 5.19725292131, 244287.60000722769],
    [0.0000000008, 6.18440483705, 1059.3819301892],
    [0.00000000069, 5.25699888595, 14143.4952424306],
    [0.00000000085, 5.39484725499, 25132.3033999656],
    [0.00000000066, 0.51779993906, 801.8209311238],
    [0.00000000055, 5.16878202461, 7058.5984613154],
    [0.00000000051, 3.88759155247, 12036.4607348882],
    [0.0000000005, 5.57636570536, 6290.1893969922],
    [0.00000000061, 2.24359003264, 8635.9420037632],
    [0.0000000005, 5.54441900966, 1990.745017041],
    [0.00000000056, 4.0030107804, 13367.9726311066],
    [0.00000000052, 4.13138898038, 7860.4193924392],
    [0.00000000052, 3.90943054011, 26.2983197998],
    [0.00000000041, 3.5712848278, 7079.3738568078],
    [0.00000000056, 2.76959005761, 90955.5516944961],
    [0.00000000042, 1.91461189199, 7477.522860216],
    [0.00000000042, 0.42728171713, 10213.285546211],
    [0.00000000042, 1.09413724455, 709.9330485583],
    [0.00000000039, 3.93298068961, 10973.55568635],
    [0.00000000038, 6.17935925345, 9917.6968745098],
    [0.00000000049, 0.83021145241, 11506.7697697936],
    [0.00000000053, 1.45828359397, 233141.31440436149],
    [0.00000000047, 6.21568666789, 6681.2248533996],
    [0.00000000037, 0.3635930998, 10177.2576795336],
    [0.00000000035, 3.33024911524, 5643.1785636774],
    [0.00000000034, 5.63446915337, 6525.8044539654],
    [0.00000000035, 5.36033855038, 25158.6017197654],
    [0.00000000034, 5.36319798321, 4933.2084403326],
    [0.00000000033, 4.24722336872, 12569.6748183318],
    [0.00000000043, 5.26370903404, 10575.4066829418],
    [0.00000000042, 5.08837645072, 11015.1064773348],
    [0.0000000004, 1.98334703186, 6284.0561710596],
    [0.00000000042, 4.22496037505, 88860.05707098669],
    [0.00000000029, 3.1908862817, 11926.2544136688],
    [0.00000000029, 0.15217616684, 12168.0026965746],
    [0.0000000003, 1.61904744136, 9779.1086761254],
    [0.00000000027, 0.76388991416, 1589.0728952838],
    [0.00000000036, 2.74712003443, 3738.761430108],
    [0.00000000033, 3.08807829566, 3930.2096962196],
    [0.00000000031, 5.34906619513, 143571.32428481648],
    [0.00000000025, 0.10240267494, 22483.84857449259],
    [0.0000000003, 3.47110495524, 14945.3161735544],
    [0.00000000024, 1.10425016019, 4535.0594369244],
    [0.00000000024, 1.5803725978, 6496.3749454294],
    [0.00000000023, 3.87710321433, 6275.9623029906],
    [0.00000000025, 3.9452977897, 3128.3887650958],
    [0.00000000023, 3.44685609601, 4136.9104335162],
    [0.00000000023, 3.83156029849, 5753.3848848968],
    [0.00000000022, 1.86956128067, 16730.4636895958],
    [0.00000000025, 2.42188933855, 5729.506447149],
    [0.0000000002, 1.78208352927, 17789.845619785],
    [0.00000000021, 4.303630874, 16858.4825329332],
    [0.00000000021, 0.49258939822, 29088.811415985],
    [0.00000000025, 1.33030250444, 6282.0955289232],
    [0.00000000027, 2.54785812264, 3496.032826134],
    [0.00000000022, 1.1123252195, 12721.572099417],
    [0.00000000021, 5.97759081637, 7.1135470008],
    [0.00000000019, 0.80292033311, 16062.1845261168],
    [0.00000000023, 4.12454848769, 2388.8940204492],
    [0.00000000022, 4.92663152168, 18875.525869774],
    [0.00000000023, 5.68902059771, 16460.33352952499],
    [0.00000000023, 4.97346265647, 17260.1546546904],
    [0.00000000023, 3.03021283729, 66567.48586525429],
    [0.00000000016, 3.89740925257, 5331.3574437408],
    [0.00000000017, 3.08268671348, 154717.60988768269],
    [0.00000000016, 3.95085099736, 3097.88382272579],
    [0.00000000016, 3.99041783945, 6283.14316029419],
    [0.0000000002, 6.10644140189, 167283.76158766549],
    [0.00000000015, 4.09775914607, 11712.9553182308],
    [0.00000000016, 5.717699407, 17298.1823273262],
    [0.00000000016, 3.28894009404, 5884.9268465832],
    [0.00000000015, 5.64785377164, 12559.038152982],
    [0.00000000016, 4.4345208093, 6283.0085396886],
    [0.00000000014, 2.31721603062, 5481.2549188676],
    [0.00000000014, 4.43479032305, 13517.8701062334],
    [0.00000000014, 4.73209312936, 7342.4577801806],
    [0.00000000012, 0.64705975463, 18073.7049386502],
    [0.00000000011, 1.514433322, 16200.7727245012],
    [0.00000000011, 0.88708889185, 21228.3920235458],
    [0.00000000014, 4.50116508534, 640.8776073822],
    [0.00000000011, 4.64339996198, 11790.6290886588],
    [0.00000000011, 1.31064298246, 4164.311989613],
    [0.00000000009, 3.02238989305, 23543.23050468179],
    [0.00000000009, 2.04999402381, 22003.9146348698],
    [0.00000000009, 4.91488110218, 213.299095438],
];

const VSOP87_R3: Vsop87Element = [
    [0.00000144595, 4.27319435148, 6283.0758499914],
    [0.00000006729, 3.91697608662, 12566.1516999828],
    [0.00000000774],
    [0.00000000247, 3.73019298781, 18849.2275499742],
    [0.00000000036, 2.8008140905, 6286.5989683404],
    [0.00000000033, 5.62216602775, 6127.6554505572],
    [0.00000000019, 3.71292621802, 6438.4962494256],
    [0.00000000016, 4.26011484232, 6525.8044539654],
    [0.00000000016, 3.50416887054, 6256.7775301916],
    [0.00000000014, 3.62127621114, 25132.3033999656],
    [0.00000000011, 4.39200958819, 4705.7323075436],
    [0.00000000011, 5.22327127059, 6040.3472460174],
    [0.0000000001, 4.28045254647, 83996.84731811189],
    [0.00000000009, 1.56864096494, 5507.5532386674],
    [0.00000000011, 1.37795688024, 6309.3741697912],
    [0.0000000001, 5.19937959068, 71430.69561812909],
    [0.00000000009, 0.4727519993, 6279.5527316424],
    [0.00000000009, 0.74642756529, 5729.506447149],
    [0.00000000007, 2.9737489156, 775.522611324],
    [0.00000000007, 3.28615691021, 7058.5984613154],
    [0.00000000007, 2.19184402142, 6812.766815086],
    [0.00000000005, 3.15419034438, 529.6909650946],
    [0.00000000006, 4.54725567047, 1059.3819301892],
    [0.00000000005, 1.51104406936, 7079.3738568078],
    [0.00000000007, 2.98052059053, 6681.2248533996],
    [0.00000000005, 2.30961231391, 12036.4607348882],
    [0.00000000005, 3.71102966917, 6290.1893969922],
];

const VSOP87_R4: Vsop87Element = [
    [0.00000003858, 2.56384387339, 6283.0758499914],
    [0.00000000306, 2.2676950123, 12566.1516999828],
    [0.00000000053, 3.44031471924, 5573.1428014331],
    [0.00000000015, 2.04794573436, 18849.2275499742],
    [0.00000000013, 2.05688873673, 77713.7714681205],
    [0.00000000007, 4.4121885448, 161000.6857376741],
    [0.00000000005, 5.26154653107, 6438.4962494256],
    [0.00000000005, 4.07695126049, 6127.6554505572],
    [0.00000000006, 3.81514213664, 149854.40013480789],
    [0.00000000003, 1.28175749811, 6286.5989683404],
];

const VSOP87_R5: Vsop87Element = [
    [0.00000000086, 1.21579741687, 6283.0758499914],
    [0.00000000012, 0.65617264033, 12566.1516999828],
    [0.00000000001, 0.38068797142, 18849.2275499742],
];

export const VSOP87_X: Vsop87Group = [VSOP87_L0, VSOP87_L1, VSOP87_L2, VSOP87_L3, VSOP87_L4, VSOP87_L5];

export const VSOP87_Y: Vsop87Group = [VSOP87_B0, VSOP87_B1, VSOP87_B2, VSOP87_B3, VSOP87_B4, VSOP87_B5];

export const VSOP87_Z: Vsop87Group = [VSOP87_R0, VSOP87_R1, VSOP87_R2, VSOP87_R3, VSOP87_R4, VSOP87_R5];
